webpackJsonp([108],{

/***/ "+2pc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_container_vue__ = __webpack_require__("IS8/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3847e286_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_container_vue__ = __webpack_require__("LIRi");
function injectStyle (ssrContext) {
  __webpack_require__("tYcp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_the_container_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3847e286_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_the_container_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+EQ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var GroupAbc = function () {
  function GroupAbc() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GroupAbc);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GroupAbc, [{
    key: 'taxByPayer',
    value: function taxByPayer(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/abc/group_taxes/by_payer/' + id);
    }
  }, {
    key: 'create',
    value: function create(groupTax) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/abc/group_taxes/', { group_tax: groupTax });
    }
  }, {
    key: 'update',
    value: function update(groupTax) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/abc/group_taxes/' + groupTax.id, { group_tax: groupTax });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete('/abc/group_taxes/' + id);
    }
  }]);

  return GroupAbc;
}();

/* harmony default export */ __webpack_exports__["a"] = (new GroupAbc());

/***/ }),

/***/ "+bCW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__ = __webpack_require__("6Rbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_base_url__ = __webpack_require__("uHIg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_signal__ = __webpack_require__("0lA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_subdomain__ = __webpack_require__("nNHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_auth__ = __webpack_require__("TIfe");





var _this = this;












var http = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_9__utils_base_url__["a" /* default */]
});

var intercepRequest = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    var token;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5_localforage___default.a.getItem('token');

          case 2:
            token = _context.sent;

            config.headers.common['Authorization'] = token;
            __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('before-request');
            return _context.abrupt('return', config);

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function intercepRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

var intercepRequestError = function intercepRequestError(error) {
  __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('request-error');
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
};

var intercepResponse = function intercepResponse(response) {
  __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('after-response');
  return response;
};

var intercepResponseError = function intercepResponseError(error) {
  console.log('intercepResponseError - error: ', error);
  console.log('intercepResponseError - error.response.data: ', error.response.data);
  console.log('intercepResponseError - error.response: ', error.response);
  var requestTags = {};
  var actionName = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.name + ' (' + __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.fullPath + ')';

  if (error.message === 'Network Error') {
    __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
      type: 'error',
      message: 'Um erro ocorreu ao entrar em contato com o servidor. Tente novamente.'
    });
  }

  __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('response-error');

  if (error.response != null) {
    if (error.response.status === 401) {
      Object(__WEBPACK_IMPORTED_MODULE_13__utils_auth__["b" /* logout */])();
    }
    if (error.response.status === 403) {
      __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: 'Você não tem permissão para acessar essa página'
      });

      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'dashboard.index' });
    }
    if (error.response.status === 422) {
      if (error.response.data) {
        __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
          type: 'error',
          message: Object(__WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
        });
      }

      error.response.data.text().then(function (data) {
        __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
          type: 'error',
          message: Object(__WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__["a" /* formatErrors */])(JSON.parse(data))
        });
      });

      error.response.then(function (data) {
        console.log('intercepResponseError - data: ', data);
        __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
          type: 'error',
          message: Object(__WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__["a" /* formatErrors */])(data)
        });
      });
    }
    if (error.response.status === 503) {
      __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
    }

    requestTags['status'] = error.response.status;
    requestTags['data'] = error.response.data;
  }

  if (error.config) {
    actionName = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.name + ' (' + __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.fullPath + '): ' + error.config.method + ' ' + error.config.url;
    requestTags['url'] = error.config.url;
    requestTags['method'] = error.config.method;
    requestTags['payload'] = error.config.params;
  }

  __WEBPACK_IMPORTED_MODULE_10__utils_signal__["a" /* default */].sendError(error, function (span) {
    span.setAction(actionName);
    span.setNamespace('creditcorp-api');
    span.setTags(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      userId: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.profile.current.id,
      userEmail: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.profile.current.email,
      routeFullPath: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.fullPath,
      routeName: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.name,
      tenant: __WEBPACK_IMPORTED_MODULE_12__utils_subdomain__["a" /* default */]
    }, requestTags));
  });
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
};

http.interceptors.request.use(intercepRequest, intercepRequestError);
http.interceptors.response.use(intercepResponse, intercepResponseError);

/* harmony default export */ __webpack_exports__["a"] = (http);

/***/ }),

/***/ "+isQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



var SET_LIST = function SET_LIST(state, obj) {
  state.list = obj;
};

var SET_TEMPLATE_CONTRACT_OPTIONS = function SET_TEMPLATE_CONTRACT_OPTIONS(state, obj) {
  state.contractTemplateOptions = obj;
};

var SET_CURRENT_ASSIGNOR = function SET_CURRENT_ASSIGNOR(state, obj) {
  state.current = obj;
};

var SET_ERRORS = function SET_ERRORS(state, obj) {
  state.errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, obj);
};

var SET_ASSIGNOR = function SET_ASSIGNOR(state, obj) {
  // WARNING! Assim garantimos que qualquer chave ja existente em state.assignor não seja removida, somente sobrescrevendo os valores das chaves necessárias
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.assignor, obj);
};

var RESET_ASSIGNOR = function RESET_ASSIGNOR(state) {
  state.assignor = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.initalAssignor));
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.initialErrors);
};

var RESET_ERRORS_DOCS = function RESET_ERRORS_DOCS(state) {
  state.errors.docs = [];
};

var UPDATE_VALUES = function UPDATE_VALUES(state, obj) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.assignor, obj);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_CURRENT_ASSIGNOR: SET_CURRENT_ASSIGNOR,
  SET_ERRORS: SET_ERRORS,
  SET_ASSIGNOR: SET_ASSIGNOR,
  RESET_ASSIGNOR: RESET_ASSIGNOR,
  RESET_ERRORS: RESET_ERRORS,
  UPDATE_VALUES: UPDATE_VALUES,
  SET_TEMPLATE_CONTRACT_OPTIONS: SET_TEMPLATE_CONTRACT_OPTIONS,
  RESET_ERRORS_DOCS: RESET_ERRORS_DOCS
});

/***/ }),

/***/ "+zLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = function index() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "eYrs"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/assignment_requests',
  name: 'assignment_requests.index',
  component: index,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "//Ep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var ImportInvoice = function () {
  function ImportInvoice() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ImportInvoice);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ImportInvoice, [{
    key: 'find',
    value: function find(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/import_invoices/' + id);
    }
  }, {
    key: 'findInvoices',
    value: function findInvoices(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/import_invoices/invoices/' + id);
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/import_invoices', payload);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete('/import_invoices/' + id);
    }
  }, {
    key: 'rebuild',
    value: function rebuild(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/import_invoices/' + id);
    }
  }, {
    key: 'sendEvaluationCerc',
    value: function sendEvaluationCerc(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/import_invoices/' + id + '/send_evaluation_cerc');
    }
  }]);

  return ImportInvoice;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ImportInvoice());

/***/ }),

/***/ "/8XT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("5Pso");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("0lAM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("WvpR");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "/REn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("DXgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("tGNB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("S0HV");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/xT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__ = __webpack_require__("6Rbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_base_url_portal__ = __webpack_require__("I+Nx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_signal__ = __webpack_require__("0lA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_subdomain__ = __webpack_require__("nNHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_auth__ = __webpack_require__("TIfe");





var _this = this;












var httpPortal = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_9__utils_base_url_portal__["a" /* default */]
});

var intercepRequest = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(config) {
    var token;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_5_localforage___default.a.getItem('token');

          case 2:
            token = _context.sent;

            config.headers.common['Authorization'] = token;
            config.headers.common['Tenant'] = __WEBPACK_IMPORTED_MODULE_12__utils_subdomain__["a" /* default */];

            __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('before-request');
            return _context.abrupt('return', config);

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function intercepRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

var intercepRequestError = function intercepRequestError(error) {
  __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('request-error');
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
};

var intercepResponse = function intercepResponse(response) {
  __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('after-response');
  return response;
};

var intercepResponseError = function intercepResponseError(error) {
  var requestTags = {};
  var actionName = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.name + ' (' + __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.fullPath + ')';

  if (error.message === 'Network Error') {
    __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
      type: 'error',
      message: 'Um erro ocorreu ao entrar em contato com o servidor. Tente novamente.'
    });
  }

  __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('response-error');

  if (error.response != null) {
    if (error.response.status === 401) {
      Object(__WEBPACK_IMPORTED_MODULE_13__utils_auth__["b" /* logout */])();
    }
    if (error.response.status === 403) {
      __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: 'Você não tem permissão para acessar essa página'
      });

      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push({ name: 'dashboard.index' });
    }
    if (error.response.status === 503) {
      __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_11__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
    }

    requestTags['status'] = error.response.status;
    requestTags['data'] = error.response.data;
  }

  if (error.config) {
    actionName = __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.name + ' (' + __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.fullPath + '): ' + error.config.method + ' ' + error.config.url;
    requestTags['url'] = error.config.url;
    requestTags['method'] = error.config.method;
    requestTags['payload'] = error.config.params;
  }

  __WEBPACK_IMPORTED_MODULE_10__utils_signal__["a" /* default */].sendError(error, function (span) {
    span.setAction(actionName);
    span.setNamespace('creditcorp-api-portal');
    span.setTags(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      userId: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.profile.current.id,
      userEmail: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.profile.current.email,
      routeFullPath: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.fullPath,
      routeName: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].app._route.name,
      tenant: __WEBPACK_IMPORTED_MODULE_12__utils_subdomain__["a" /* default */]
    }, requestTags));
  });
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
};

httpPortal.interceptors.request.use(intercepRequest, intercepRequestError);
httpPortal.interceptors.response.use(intercepResponse, intercepResponseError);

/* harmony default export */ __webpack_exports__["a"] = (httpPortal);

/***/ }),

/***/ "091e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_profile__ = __webpack_require__("h9qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_subdomain__ = __webpack_require__("nNHA");




var _this = this;







var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_profile__["a" /* default */].fetch().then(function (response) {
                if (response.data.user_type === 'Cedente') {
                  Object(__WEBPACK_IMPORTED_MODULE_6__utils_auth__["b" /* logout */])();
                  var mainURI = window.location.host.split('.');
                  var domain = mainURI.length > 2 ? mainURI.slice(-3).join('.') : mainURI[1];
                  var protocol = "https://";
                  window.location.href = protocol + 'fornecedores.' + __WEBPACK_IMPORTED_MODULE_7__utils_subdomain__["a" /* default */] + '.' + domain;
                  return;
                }
                commit('SET_CURRENT_USER', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var save = function save(_ref3, user) {
  var commit = _ref3.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_profile__["a" /* default */].save(user).then(function (response) {
      commit('SET_CURRENT_USER', response.data);
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  save: save
});

/***/ }),

/***/ "0lA/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appsignal_javascript__ = __webpack_require__("LQFq");


var appsignal = new __WEBPACK_IMPORTED_MODULE_0__appsignal_javascript__["a" /* default */]({ key: "c1ad617f-bed0-443c-9ce2-aef7f07aa51b" });

/* harmony default export */ __webpack_exports__["a"] = (appsignal);

/***/ }),

/***/ "0lAM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var SET_LIST = function SET_LIST(state, obj) {
  state.list = obj;
};

var SET_ERRORS_DOCS = function SET_ERRORS_DOCS(state, obj) {
  state.errors.docs = obj;
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.initialErrors);
};

var RESET_ERRORS_DOCS = function RESET_ERRORS_DOCS(state) {
  state.errors.docs = [];
};

/* harmony default export */ __webpack_exports__["a"] = ({
  RESET_ERRORS: RESET_ERRORS,
  SET_ERRORS_DOCS: SET_ERRORS_DOCS,
  RESET_ERRORS_DOCS: RESET_ERRORS_DOCS,
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "0waH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_metronic_input_template_vue__ = __webpack_require__("BUOe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac453da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_metronic_input_template_vue__ = __webpack_require__("hPAr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_metronic_input_template_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac453da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_metronic_input_template_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1+PW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("mNto");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "1gP2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http_portal__ = __webpack_require__("0/xT");




var Worker = function () {
  function Worker() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Worker);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Worker, [{
    key: 'jobStatus',
    value: function jobStatus(jobID) {
      return __WEBPACK_IMPORTED_MODULE_2__http_portal__["a" /* default */].get('/private/worker/data/' + jobID);
    }
  }]);

  return Worker;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Worker());

/***/ }),

/***/ "2/gM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_tour__ = __webpack_require__("yvd/");




var _this = this;



var fetchFinishTour = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_tour__["a" /* default */].end().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchFinishTour(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchFinishTour: fetchFinishTour
});

/***/ }),

/***/ "2Uks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var list = function list() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "gKfl"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/invoices',
  name: 'import_invoices.index',
  component: list,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "2pMd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Tenant = function () {
  function Tenant() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tenant);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Tenant, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/tenant_representatives');
    }
  }, {
    key: 'reset',
    value: function reset(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/reset_tenant', { password: payload });
    }
  }]);

  return Tenant;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Tenant());

/***/ }),

/***/ "2tuA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_manage_invoice__ = __webpack_require__("3cR5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var changeStatus = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
    var commit = _ref2.commit;
    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { invoice_ids: [], rescue_status: '' };
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_manage_invoice__["a" /* default */].changeStatus(obj).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                            type: 'error',
                            message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                          });
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function changeStatus(_x) {
    return _ref.apply(this, arguments);
  };
}();

var sendDocs = function sendDocs(_ref4, payload) {
  var commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_manage_invoice__["a" /* default */].sendDocs(payload).then(function (response) {
                commit('RESET_ERRORS_DOCS');
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS_DOCS', error.response.data);
                reject(error);
              });

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }());
};

var changeStatusDoc = function changeStatusDoc(_ref6, payload) {
  var commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_manage_invoice__["a" /* default */].changeStatusDoc(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS_DOCS', error.response.data);
                reject(error);
              });

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }());
};

var resetErrors = function resetErrors(_ref8) {
  var commit = _ref8.commit;

  commit('RESET_ERRORS_DOCS');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  changeStatus: changeStatus,
  sendDocs: sendDocs,
  changeStatusDoc: changeStatusDoc,
  resetErrors: resetErrors
});

/***/ }),

/***/ "39Xj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http_portal__ = __webpack_require__("0/xT");





var Dashboard = function () {
  function Dashboard() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Dashboard);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Dashboard, [{
    key: 'statusMailer',
    value: function statusMailer(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors_preview/status_mailer', { params: { filter: payload } });
    }
  }, {
    key: 'statusAccount',
    value: function statusAccount(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors_preview/status_accounts', { params: { filter: payload } });
    }
  }, {
    key: 'statusDocumentations',
    value: function statusDocumentations(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors_preview/status_documentations', { params: { filter: payload } });
    }
  }, {
    key: 'statusAssignments',
    value: function statusAssignments(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignments_preview/status_assignments', { params: { filter: payload } });
    }
  }, {
    key: 'statusAssignmentsAccepted',
    value: function statusAssignmentsAccepted(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignments_preview/status_accepted', { params: { filter: payload } });
    }
  }, {
    key: 'statusAssignmentsRejectedCanceled',
    value: function statusAssignmentsRejectedCanceled(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignments_preview/status_rejected_canceled', { params: { filter: payload } });
    }
  }, {
    key: 'statusAssignmentsCompleted',
    value: function statusAssignmentsCompleted(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors_preview/status_complete');
    }
  }, {
    key: 'getSummary',
    value: function getSummary() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors/summary');
    }
  }, {
    key: 'fetchCorretor',
    value: function fetchCorretor() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors/corretor');
    }
  }, {
    key: 'fetchForceRequest',
    value: function fetchForceRequest(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/admin_back_office/force_send_assignment_request/' + payload.id);
    }
  }, {
    key: 'exportCnabFile',
    value: function exportCnabFile(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_cnab_file/' + id + '/download');
    }
  }, {
    key: 'generateTermoCessao',
    value: function generateTermoCessao(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_assignment_request_term/' + id, {
        responseType: 'blob',
        headers: { accept: 'application/json' }
      });
    }
  }, {
    key: 'exportExcelAssigmentRequest',
    value: function exportExcelAssigmentRequest(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_assignment_request_excel/' + id, {
        responseType: 'blob',
        headers: { accept: 'application/json' }
      });
    }
  }, {
    key: 'exportCnabFileFromMultipleARs',
    value: function exportCnabFileFromMultipleARs(ids) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_cnab_file/download', { params: { assignment_requests_ids: ids } });
    }
  }, {
    key: 'loadSummaryDatatable',
    value: function loadSummaryDatatable(params) {
      var path = params ? 'private/api/v1/invoices_summarize' + '?' + params : 'private/api/v1/invoices_summarize';
      return __WEBPACK_IMPORTED_MODULE_3__http_portal__["a" /* default */].get(path);
    }
  }]);

  return Dashboard;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Dashboard());

/***/ }),

/***/ "3cR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var ManageInvoice = function () {
  function ManageInvoice() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ManageInvoice);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ManageInvoice, [{
    key: 'changeStatus',
    value: function changeStatus(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/manager_invoices', payload);
    }
  }, {
    key: 'sendDocs',
    value: function sendDocs(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/manage_invoice_documents/new', payload);
    }
  }, {
    key: 'changeStatusDoc',
    value: function changeStatusDoc(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/manage_invoice_documents/change_status', payload);
    }
  }]);

  return ManageInvoice;
}();

/* harmony default export */ __webpack_exports__["a"] = (new ManageInvoice());

/***/ }),

/***/ "3dTy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("sD8V");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "3fxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select2_select2_js__ = __webpack_require__("lXst");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__select2_select2_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__select2_select2_js__);


//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Select2',
  data: function data() {
    return {
      select2: null
    };
  },

  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: function _default() {}
    },
    value: null
  },
  watch: {
    options: function options(val) {
      this.setOption(val);
    },
    value: function value(val) {
      this.setValue(val);
    }
  },
  methods: {
    setOption: function setOption() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.select2.empty();
      this.select2.select2(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.settings, {
        data: val
      }));
      this.setValue(this.value);
    },
    setValue: function setValue(val) {
      if (val instanceof Array) {
        this.select2.val([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(val)));
      } else {
        this.select2.val([val]);
      }
      this.select2.trigger('change');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.select2 = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('select').select2(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.settings, {
      data: this.options
    })).on('select2:select select2:unselect', function (ev) {
      var _ev$params$data = ev['params']['data'],
          id = _ev$params$data.id,
          text = _ev$params$data.text,
          selected = _ev$params$data.selected;

      var selectValue = _this.select2.val();
      _this.$emit('change', selectValue);
      _this.$emit('select', { id: id, text: text, selected: selected });
    });
    this.setValue(this.value);
  },
  beforeDestroy: function beforeDestroy() {
    this.select2.select2('destroy');
  }
});

/***/ }),

/***/ "3z+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var SET_INVOICES_TOTAL = function SET_INVOICES_TOTAL(state, payload) {
  state.invoicesTotal = payload;
};

var SET_INVOICES_SELECTED = function SET_INVOICES_SELECTED(state, payload) {
  state.invoicesSelected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload, {
    errors: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(payload.errors).reduce(function (errors, error) {
      if (error[0] === 'payer') {
        errors = errors.concat(error[1]);
      }
      return errors;
    }, [])
  });
};

var SET_TAX_COMMISSION = function SET_TAX_COMMISSION(state, payload) {
  state.taxCommission = payload;
};

var REMOVE_INVOICE_SELECTED = function REMOVE_INVOICE_SELECTED(state, invoice) {
  Object(__WEBPACK_IMPORTED_MODULE_3_lodash__["remove"])(state.invoicesSelected.invoices, {
    id: invoice
  });
};
var RESET_INVOICES = function RESET_INVOICES(state) {
  state.invoicesSelected = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.initialInvoicesSelected));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_INVOICES_TOTAL: SET_INVOICES_TOTAL,
  SET_INVOICES_SELECTED: SET_INVOICES_SELECTED,
  SET_TAX_COMMISSION: SET_TAX_COMMISSION,
  REMOVE_INVOICE_SELECTED: REMOVE_INVOICE_SELECTED,
  RESET_INVOICES: RESET_INVOICES
});

/***/ }),

/***/ "4KJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_bank__ = __webpack_require__("W7+p");




var _this = this;



var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_bank__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var FindBanksByAssignor = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_bank__["a" /* default */].fetchByAssignor().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function FindBanksByAssignor(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  FindBanksByAssignor: FindBanksByAssignor
});

/***/ }),

/***/ "4sDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: []
});

/***/ }),

/***/ "4zFs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__("+bCW");





var Auth = function () {
  function Auth() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Auth);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Auth, [{
    key: 'login',
    value: function login(email, password) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post('/user_token', { auth: { email: email, password: password } });
    }
  }, {
    key: 'redirectLogin',
    value: function redirectLogin(token) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post('/auths/redirects/verify', {
        auth_redirect_access_verify: { redirect_token: token }
      });
    }
  }, {
    key: 'resetEmail',
    value: function resetEmail(email) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post('/passwords', { email: email });
    }
  }, {
    key: 'validate',
    value: function validate(payload) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get('/passwords/' + payload);
    }
  }, {
    key: 'changePassword',
    value: function changePassword(payload) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].put('/passwords/' + payload.token, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload.user));
    }
  }, {
    key: 'acceptTerms',
    value: function acceptTerms() {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post('user_term_agreement');
    }
  }]);

  return Auth;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Auth());

/***/ }),

/***/ "4zUY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("C8xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("9PJk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mutations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("P9hr");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state___default.a,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations___default.a,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "5J0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Assignor = function () {
  function Assignor() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Assignor);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Assignor, [{
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors/' + id);
    }
  }, {
    key: 'all',
    value: function all() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors?per_page=all');
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/assignors', { assignor: payload });
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/assignors/' + payload.id, { assignor: payload });
    }
  }, {
    key: 'allElegible',
    value: function allElegible() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors_eligible?per_page=100');
    }
  }, {
    key: 'current',
    value: function current() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/current_assignor');
    }
  }, {
    key: 'withInvoices',
    value: function withInvoices() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors_with_invoices');
    }
  }, {
    key: 'documents',
    value: function documents(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors/' + id + '/get_assignor_documentation');
    }
  }, {
    key: 'users',
    value: function users(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/api/assignors/' + id + '/users');
    }
  }, {
    key: 'byPayers',
    value: function byPayers() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors_by_payer');
    }
  }, {
    key: 'getClassifiedAssignorByPayer',
    value: function getClassifiedAssignorByPayer(payerId, queryParams) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/abc/class_assignors/assignors_with_classification/by_payer/' + payerId, { params: queryParams });
    }
  }, {
    key: 'classification',
    value: function classification(groupTaxId, assignorId) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/abc/class_assignors/classify/' + groupTaxId, {
        assignor_id: assignorId
      });
    }
  }, {
    key: 'checkSerasa',
    value: function checkSerasa(assignorId) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors_serasa/' + assignorId);
    }
  }, {
    key: 'sendDocumentations',
    value: function sendDocumentations(id, payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/assignors/' + id + '/send_documentations', payload);
    }
  }, {
    key: 'templateContractOptions',
    value: function templateContractOptions() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors/template_contract_options');
    }
  }, {
    key: 'byToken',
    value: function byToken(token) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/user_assignors/token/' + token);
    }
  }, {
    key: 'withProtesto',
    value: function withProtesto(token) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('assignors_with_protestos/campaign/' + token);
    }
  }, {
    key: 'saveByToken',
    value: function saveByToken(token, user) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/user_assignors/' + token, { user: user });
    }
  }, {
    key: 'destroyRepresentativeDocument',
    value: function destroyRepresentativeDocument(representativeId, documentId) {
      var payload = {
        assignor_representative_id: representativeId,
        document_id: documentId
      };
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete('/assignors/destroy_representative_documentation', { params: payload });
    }
  }]);

  return Assignor;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Assignor());

/***/ }),

/***/ "5Pso":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var errors = {
  docs: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors)
});

/***/ }),

/***/ "5XNM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("sQep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("CE23");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("4KJ9");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "5fV2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Campaign = function () {
  function Campaign() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Campaign);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Campaign, [{
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/campaigns/' + id);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/campaigns');
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/campaigns', { campaign: payload });
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/campaigns/' + payload.id, { campaign: payload });
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/campaigns/' + id + '/send_campaign');
    }
  }, {
    key: 'datasInvoices',
    value: function datasInvoices(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/campaigns/datas_of_invoices', payload);
    }
  }, {
    key: 'fetchAvailableAssignors',
    value: function fetchAvailableAssignors(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/campaigns/assignors/available/' + id);
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/payer_assignors/change_assignor_available_to_campaign_status', payload);
    }
  }, {
    key: 'changeStatusAproveReject',
    value: function changeStatusAproveReject(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/payer_assignors/change_assignor_need_approval_create_assignment_request', payload);
    }
  }]);

  return Campaign;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Campaign());

/***/ }),

/***/ "6Rbp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bus; });
/* harmony export (immutable) */ __webpack_exports__["b"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();



function install(Vue) {
  Object.defineProperty(Vue.prototype, '$bus', {
    get: function get() {
      return bus;
    }
  });
}

/***/ }),

/***/ "6pID":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var AssignmentRequest = function () {
  function AssignmentRequest() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AssignmentRequest);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AssignmentRequest, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignment_requests');
    }
  }, {
    key: 'status',
    value: function status() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/dashboard/assignors/status');
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/assignment_requests', payload);
    }
  }, {
    key: 'accept',
    value: function accept(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/dashboard/payers/assignment_requests/' + id + '/approve_assignor_assignment_request');
    }
  }, {
    key: 'reject',
    value: function reject(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/dashboard/payers/assignment_requests/' + id + '/reject_assignor_assignment_request');
    }
  }]);

  return AssignmentRequest;
}();

/* harmony default export */ __webpack_exports__["a"] = (new AssignmentRequest());

/***/ }),

/***/ "6xbw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_step__ = __webpack_require__("oqcA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var find = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_step__["a" /* default */].fetch().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function find(_x) {
    return _ref.apply(this, arguments);
  };
}();

var save = function save(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_step__["a" /* default */].save(payload.assignor).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data.errors)
      });
      reject(error);
    });
  });
};

var sendDocumentation = function sendDocumentation(context) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_step__["a" /* default */].sendDoc().then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  find: find,
  save: save,
  sendDocumentation: sendDocumentation
});

/***/ }),

/***/ "6zyl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Serasa = function () {
  function Serasa() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Serasa);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Serasa, [{
    key: 'approveProtestos',
    value: function approveProtestos(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/serasa_concentre_query_requests/' + id + '/approve_protestos');
    }
  }, {
    key: 'rejectProtestos',
    value: function rejectProtestos(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/serasa_concentre_query_requests/' + id + '/reject_protestos');
    }
  }]);

  return Serasa;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Serasa());

/***/ }),

/***/ "8bjO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("dUai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("+isQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("yoEW");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "8tHh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("vGk4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("zwPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("JXHy");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "8tJU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_dashboard__ = __webpack_require__("39Xj");




var _this = this;



var fetchStatusMailer = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusMailer(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchStatusMailer(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchStatusAccount = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusAccount(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchStatusAccount(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var fetchStatusDocumentations = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusDocumentations(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function fetchStatusDocumentations(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchStatusAssignments = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusAssignments(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function fetchStatusAssignments(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

var fetchStatusAssignmentsAccepted = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusAssignmentsAccepted(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function fetchStatusAssignmentsAccepted(_x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchStatusAssignmentsRejectedCanceled = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusAssignmentsRejectedCanceled(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function fetchStatusAssignmentsRejectedCanceled(_x11, _x12) {
    return _ref6.apply(this, arguments);
  };
}();

var fetchStatusComplete = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(context) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_dashboard__["a" /* default */].statusAssignmentsCompleted().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function fetchStatusComplete(_x13) {
    return _ref7.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchStatusMailer: fetchStatusMailer,
  fetchStatusAccount: fetchStatusAccount,
  fetchStatusDocumentations: fetchStatusDocumentations,
  fetchStatusAssignments: fetchStatusAssignments,
  fetchStatusComplete: fetchStatusComplete,
  fetchStatusAssignmentsAccepted: fetchStatusAssignmentsAccepted,
  fetchStatusAssignmentsRejectedCanceled: fetchStatusAssignmentsRejectedCanceled
});

/***/ }),

/***/ "9+ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var hasValue = function hasValue() {
  for (var _len = arguments.length, itens = Array(_len), _key = 0; _key < _len; _key++) {
    itens[_key] = arguments[_key];
  }

  itens = itens.map(function (item) {
    return item !== undefined && item !== '' && item !== null;
  });

  return !itens.includes(false);
};

var getCnpjsParams = function getCnpjsParams(cnpjs, key) {
  if (typeof cnpjs === 'string') {
    return key + '[]=' + cnpjs.split(',').join('&' + key + '[]=');
  } else {
    if (cnpjs.length === 0) {
      return key + '[]=';
    } else {
      return key + '[]=' + cnpjs.join('&' + key + '[]=');
    }
  }
};

var SET_DASHBOARD_SUMMARY = function SET_DASHBOARD_SUMMARY(state, list) {
  state.dashboardSummary = list;
};

var SET_DASHBOARD = function SET_DASHBOARD(state, list) {
  state.dashboard = list;
};

var SET_CORRETOR = function SET_CORRETOR(state, list) {
  state.corretor = list;
};

var SET_SUMMARY_DATATABLE = function SET_SUMMARY_DATATABLE(state, obj) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.summaryDatatable, obj);
};

var SET_PARAMS_QUERY_SUMMARY_DATATABLE = function SET_PARAMS_QUERY_SUMMARY_DATATABLE(state) {
  // CNPJ
  var params = getCnpjsParams(state.summaryDatatable.cnpjs, 'assignor');

  // params cnpj_payer
  params += '&' + getCnpjsParams(state.summaryDatatable.cnpjs_payers, 'payer');

  // Programada
  if (hasValue(state.summaryDatatable.scheduled_date_init, state.summaryDatatable.scheduled_date_end)) {
    params += '&scheduled_date_init=' + state.summaryDatatable.scheduled_date_init + '&scheduled_date_end=' + state.summaryDatatable.scheduled_date_end;
  }
  // Pagamento
  if (hasValue(state.summaryDatatable.payment_date_init, state.summaryDatatable.payment_date_end)) {
    params += '&payment_date_init=' + state.summaryDatatable.payment_date_init + '&payment_date_end=' + state.summaryDatatable.payment_date_end;
  }
  // Status
  if (hasValue(state.summaryDatatable.status)) {
    params += '&status=' + state.summaryDatatable.status;
  }
  // Numero Titulo
  if (hasValue(state.summaryDatatable.invoice_number)) {
    params += '&invoice_number=' + state.summaryDatatable.invoice_number;
  }
  state.summaryDatatable.paramsQuery = params;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SUMMARY_DATATABLE: SET_SUMMARY_DATATABLE,
  SET_PARAMS_QUERY_SUMMARY_DATATABLE: SET_PARAMS_QUERY_SUMMARY_DATATABLE,
  SET_DASHBOARD_SUMMARY: SET_DASHBOARD_SUMMARY,
  SET_DASHBOARD: SET_DASHBOARD,
  SET_CORRETOR: SET_CORRETOR
});

/***/ }),

/***/ "9GhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Permissions = function () {
  function Permissions() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Permissions);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Permissions, [{
    key: 'fetchByType',
    value: function fetchByType(usetType) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/permissions/' + usetType);
    }
  }, {
    key: 'saveAvatar',
    value: function saveAvatar(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/users/' + payload.id + '/avatar', payload.data);
    }
  }]);

  return Permissions;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Permissions());

/***/ }),

/***/ "9PH6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Invoice = function () {
  function Invoice() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Invoice);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Invoice, [{
    key: 'available',
    value: function available(page) {
      var url = page !== undefined ? '/invoices/available_invoices?page=' + page : '/invoices/available_invoices';
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get(url);
    }
  }, {
    key: 'filterAvailable',
    value: function filterAvailable(filter) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/invoices/available_invoices?filter=' + filter);
    }
  }, {
    key: 'totalAvailable',
    value: function totalAvailable() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/invoices/total_available_invoices');
    }
  }, {
    key: 'selectedAvailable',
    value: function selectedAvailable(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/invoices/selected_available_invoices', payload);
    }
  }, {
    key: 'simulate',
    value: function simulate(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/invoices/simulate', payload);
    }
  }, {
    key: 'taxCommission',
    value: function taxCommission() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/invoices/tax_commission');
    }
  }, {
    key: 'exampleInvoiceRequest',
    value: function exampleInvoiceRequest(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/invoice_request/example', payload);
    }
  }, {
    key: 'saveInvoiceRequest',
    value: function saveInvoiceRequest(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/invoice_request', payload);
    }
  }, {
    key: 'byAssignor',
    value: function byAssignor(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/invoices_by_assignor/' + payload);
    }
  }]);

  return Invoice;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Invoice());

/***/ }),

/***/ "9PJk":
/***/ (function(module, exports) {



/***/ }),

/***/ "A7iJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Documents = function () {
  function Documents() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Documents);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Documents, [{
    key: 'sendPayerDocs',
    value: function sendPayerDocs(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/payers/upload_docs', payload);
    }
  }, {
    key: 'sendAssignorDocs',
    value: function sendAssignorDocs(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/manage_documents/new_document', payload);
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/manage_documents/change_status', payload);
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/manage_documents/update', payload);
    }
  }]);

  return Documents;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Documents());

/***/ }),

/***/ "ABFm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var invoicesWithoutOccurrences = function invoicesWithoutOccurrences(state) {
  return state.summaryDatatable.total_occurrences === 0;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  invoicesWithoutOccurrences: invoicesWithoutOccurrences
});

/***/ }),

/***/ "BSzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("kKmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("mHHP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__mutations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("gOx0");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state___default.a,
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations___default.a,
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "BUOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_error_extractor__ = __webpack_require__("Vp0C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_error_extractor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_error_extractor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vuelidate_error_extractor__["extractorMixin"]]
});

/***/ }),

/***/ "BVeW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("vrOo");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "C8xI":
/***/ (function(module, exports) {



/***/ }),

/***/ "CDY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("zcS/");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "CE23":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, obj) {
  state.list = obj;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "CHrz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_invoice__ = __webpack_require__("9PH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var fetchExampleInvoiceRequest = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, obj) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].exampleInvoiceRequest().then(function (response) {
                commit('SET_EXAMPLE', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchExampleInvoiceRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var save = function save(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].saveInvoiceRequest(payload).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchExampleInvoiceRequest: fetchExampleInvoiceRequest,
  save: save
});

/***/ }),

/***/ "CIt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var IndexSupplierProgram = function IndexSupplierProgram() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "/227"));
};
var DetailSupplierProgram = function DetailSupplierProgram() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "KGmA"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/antecipation_requests',
  name: 'antecipation_requests.index',
  component: IndexSupplierProgram,
  meta: { requiresAuth: true }
}, {
  path: '/antecipation_requests/:id/details',
  name: 'antecipation_requests.detail',
  component: DetailSupplierProgram,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "CJr+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("2/gM");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "CRKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_campaign__ = __webpack_require__("5fV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAvailableAssignors = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payerId) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].fetchAvailableAssignors(payerId).then(function (response) {
                commit('SET_LIST_AVAILABLE', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchAvailableAssignors(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var find = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].get(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function find(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();

var save = function save(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
      var verb, campaign, method;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              verb = payload.verb, campaign = payload.campaign;
              method = verb === 'put' ? 'update' : 'save';


              __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */][method](campaign).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });

            case 3:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }());
};

var sendMail = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].sendEmail(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function sendMail(_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();

var datasInvoices = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref9, payload) {
    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].datasInvoices(payload).then(function (response) {
                commit('SET_INFORMATION', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function datasInvoices(_x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();

var resetStateInformation = function resetStateInformation(_ref10) {
  var commit = _ref10.commit;

  commit('RESET_INFORMATION');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  fetchAvailableAssignors: fetchAvailableAssignors,
  find: find,
  save: save,
  sendMail: sendMail,
  datasInvoices: datasInvoices,
  resetStateInformation: resetStateInformation
});

/***/ }),

/***/ "Cgbl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_NOTIFICATIONS = function SET_NOTIFICATIONS(state, payload) {
  state.list = payload;
};

var REMOVE_NOTIFICATION = function REMOVE_NOTIFICATION(state, payload) {
  state.list = state.list.filter(function (notification) {
    return notification.id !== payload.id;
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_NOTIFICATIONS: SET_NOTIFICATIONS,
  REMOVE_NOTIFICATION: REMOVE_NOTIFICATION
});

/***/ }),

/***/ "DCaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  listInvoices: [],
  graphInvoices: {}
});

/***/ }),

/***/ "DUsA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("ItDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("3z+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("pWIH");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "DXgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: []
});

/***/ }),

/***/ "Difv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E0LF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("TqjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("KLBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("CHrz");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "EZfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Select2_vue__ = __webpack_require__("3fxR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a842b0d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Select2_vue__ = __webpack_require__("Difv");
function injectStyle (ssrContext) {
  __webpack_require__("wUKe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Select2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a842b0d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Select2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FLY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = function index() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "uzTo"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/assignments',
  name: 'assignments.index',
  component: index,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "G5rA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("6xbw");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "GLqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var SET_CURRENT = function SET_CURRENT(state, payload) {
  state.current = payload;
};

var SET_ERRORS = function SET_ERRORS(state, payload) {
  state.errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload);
};

var SET_PAYER = function SET_PAYER(state, payload) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.payer, payload);
};

var RESET_PAYER = function RESET_PAYER(state) {
  state.payer = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.initialPayer));
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.initialErrors);
};

var UPDATE_VALUES = function UPDATE_VALUES(state, payload) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.payer, payload);
};

var SET_LIST_TO_CAMPAIGN = function SET_LIST_TO_CAMPAIGN(state, payload) {
  state.listToCampaign = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_CURRENT: SET_CURRENT,
  SET_ERRORS: SET_ERRORS,
  SET_PAYER: SET_PAYER,
  RESET_PAYER: RESET_PAYER,
  RESET_ERRORS: RESET_ERRORS,
  UPDATE_VALUES: UPDATE_VALUES,
  SET_LIST_TO_CAMPAIGN: SET_LIST_TO_CAMPAIGN
});

/***/ }),

/***/ "GtEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: []
});

/***/ }),

/***/ "HE03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Settings = function () {
  function Settings() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Settings);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Settings, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/settings');
    }
  }, {
    key: 'bankAccount',
    value: function bankAccount() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/settings/bank_account');
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/settings', payload);
    }
  }, {
    key: 'load',
    value: function load() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/publics/system_settings');
    }
  }]);

  return Settings;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Settings());

/***/ }),

/***/ "HExQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = function index() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "7eMR"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/payer/assignment_requests',
  name: 'payers.assignment_requests',
  component: index,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "I+Nx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUrl = "" + "https://" + "#";

/* harmony default export */ __webpack_exports__["a"] = (baseUrl);

/***/ }),

/***/ "I48w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var LiquidationRequest = function () {
  function LiquidationRequest() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, LiquidationRequest);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(LiquidationRequest, [{
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/liquidation_requests', { liquidation_request: payload });
    }
  }, {
    key: 'fetchInvoices',
    value: function fetchInvoices(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/liquidation_requests/total_invoices', { liquidation_request: payload });
    }
  }, {
    key: 'exportCnabFile',
    value: function exportCnabFile(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_cnab_file_liquidation/' + id + '/download');
    }
  }]);

  return LiquidationRequest;
}();

/* harmony default export */ __webpack_exports__["a"] = (new LiquidationRequest());

/***/ }),

/***/ "IRd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_liquidation_request__ = __webpack_require__("I48w");




var _this = this;



var save = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_liquidation_request__["a" /* default */].save(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function save(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchInvoicesSelectedAdmin = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, payload) {
    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_liquidation_request__["a" /* default */].fetchInvoices(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchInvoicesSelectedAdmin(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var exportCnabFile = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_liquidation_request__["a" /* default */].exportCnabFile(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function exportCnabFile(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  save: save,
  fetchInvoicesSelectedAdmin: fetchInvoicesSelectedAdmin,
  exportCnabFile: exportCnabFile
});

/***/ }),

/***/ "IS8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_min_css__ = __webpack_require__("kAs5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_min_css__);



//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TheContainer',
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.loadSystemSettings();

            case 2:
              _context.next = 4;
              return _this.applyStyleCss();

            case 4:
              _this.$bus.$on('display-alert', function (obj) {
                var type = obj.type,
                    message = obj.message;

                _this.$notify({ type: type, text: message });
              });
              _this.verifyNewCurrent();

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      isLoading: false,
      keepLoading: false
    };
  },

  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a
  },
  created: function created() {
    this.$bus.$on('set-keep-loading', this.keepLoadingOn);
    this.$bus.$on('unset-keep-loading', this.keepLoadingOff);
    this.$bus.$on('before-request', this.showSpinner);
    this.$bus.$on('request-error', this.hideSpinner);
    this.$bus.$on('after-response', this.hideSpinner);
    this.$bus.$on('response-error', this.hideSpinner);
    this.$bus.$on('apply-color-css', this.applyStyleCss);
  },
  beforeDestroy: function beforeDestroy() {
    this.$bus.$off('set-keep-loading', this.keepLoadingOn);
    this.$bus.$off('unset-keep-loading', this.keepLoadingOff);
    this.$bus.$off('before-request', this.showSpinner);
    this.$bus.$off('request-error', this.hideSpinner);
    this.$bus.$off('after-response', this.hideSpinner);
    this.$bus.$off('response-error', this.hideSpinner);
    this.$bus.$off('apply-color-css');
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('permissions', ['fetch']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('switchUsers', ['getNewCurrent']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('settings', ['loadSystemSettings']), {
    keepLoadingOn: function keepLoadingOn() {
      this.keepLoading = true;
    },
    keepLoadingOff: function keepLoadingOff() {
      this.keepLoading = false;
      this.isLoading = false;
    },
    showSpinner: function showSpinner() {
      this.isLoading = true;
    },
    hideSpinner: function hideSpinner() {
      if (!this.keepLoading) {
        this.isLoading = false;
      }
    },
    verifyNewCurrent: function verifyNewCurrent() {
      this.getNewCurrent();
    },
    applyStyleCss: function applyStyleCss() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var settings, css, style, linkFavicon;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this2.notHaveColors) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this2.loadSystemSettings();

              case 3:
                settings = _this2.systemSettings;
                css = [
                // PRIMARY-COLOR
                '.skin-background-1 { background-color: ' + settings.primary_color + ' !important; }', // CLASSE PARA FUNDOS COR PRIMARIA
                '.skin-border-1 { border: 1px solid ' + settings.primary_color + ' !important; }', // CLASSE PARA BORDAR COR PRIMARIA
                '.skin-background-1-hover:hover:not(.link-active-exact) { background-color: ' + settings.primary_color + ' !important; color: white !important; }', // CLASSE PARA FUNDOS HOVER COR PRIMARIA
                '.skin-title-1 { color: ' + settings.primary_color + ' !important }', // CLASSE PARA TITULOS COR PRIMARIA
                '.skin-dropdown-1-focus:focus { background-color: ' + settings.primary_color + ' !important; color: white; }', // CLASSE PARA FUNDOS FOCUS COR PRIMARIA
                '.link-active-exact, .link-active-exact a { color: white; background-color: ' + settings.primary_color + ' !important; opacity: 0.88 !important }', // Alterando cor de menu selecionado para levar em conta as cores do sistema
                '.skin-background-1-active:active { background-color: ' + settings.primary_color + ' !important; color: white; }', // CLASSE PARA FUNDOS ACTIVE COR PRIMARIA

                // SECUNDARY-COLOR
                '.skin-background-2 { background-color: ' + settings.secundary_color + ' !important; }', // CLASSE PARA FUNDOS COR SECUNDARIA
                '.skin-dropdown-2-focus:focus { background-color: ' + settings.secundary_color + ' !important; color: white; }', // CLASSE PARA FUNDOS ACTIVE COR SECUNDARIA
                '.skin-background-2-active:active { background-color: ' + settings.secundary_color + ' !important; color: white; }', // CLASSE PARA FUNDOS FOCUS COR SECUNDARIA
                '.skin-border-2 { border: 1px solid ' + settings.secundary_color + ' !important; }', // CLASSE PARA BORDAR COR SECUNDARIA
                'div .v-step { background-color: ' + settings.secundary_color + ' !important; }', // Alterando cor do fundo da DIV do tour
                '.v-step .v-step__arrow[data-v-570be51d] { border-color: ' + settings.secundary_color + ' !important; }', // Alterando cor da seta da DIV do tour
                '.skin-background-2-hover:hover:not(.link-active-exact) { background-color: ' + settings.secundary_color + ' !important; color: ' + settings.menu_text_color + '; }', // CLASSE PARA FUNDOS HOVER COR SECUNDARIA

                // THIRD-COLOR
                '.skin-title-2 { color: ' + settings.third_color + ' }',

                // MENU-TEXT-COLOR
                '.skin-menu-color-1 a { color: ' + settings.menu_text_color + ' }', // CLASSE PARA COR DA FONTE NO MENU
                '.text-logout, .icon-header-custom { color: ' + settings.menu_text_color + ' !important; }', // CLASSE PARA COR NOS ICONES DO HEADER
                '.skin-subtitle { color: ' + settings.subtitle_text_color + ' !important  }' // CLASSE PARA COR DOS SUBTITULOS
                ];
                style = document.createElement('style');

                css.forEach(function (element) {
                  style.appendChild(document.createTextNode(element));
                });

                /* ADICIONANDO OUTRAS CONFIG */
                document.title = settings.title;
                linkFavicon = document.querySelector('link[rel*=\'icon\']');

                linkFavicon.href = settings.favicon_url;

                document.getElementsByTagName('head')[0].appendChild(style);
                document.getElementsByTagName('head')[0].appendChild(linkFavicon);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])('settings', {
    systemSettings: function systemSettings(state) {
      return state.systemSettings;
    },
    notHaveColors: function notHaveColors(state) {
      return state.systemSettings.primary_color === '' && state.systemSettings.secundary_color === '';
    }
  }))
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_user_store__ = __webpack_require__("YzSA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_permissions_store__ = __webpack_require__("/REn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_settings_store__ = __webpack_require__("8tHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_clients_store__ = __webpack_require__("bDg4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_payers_store__ = __webpack_require__("swCI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_assignors_store__ = __webpack_require__("8bjO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_import_invoices_store__ = __webpack_require__("hFK4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_campaigns_store__ = __webpack_require__("MCOF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_invoices_store__ = __webpack_require__("DUsA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_assignment_request_store__ = __webpack_require__("Q5jr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_antecipation_request_store__ = __webpack_require__("CDY5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_dashboard_store__ = __webpack_require__("jYXb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_steps_store__ = __webpack_require__("G5rA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_banks_store__ = __webpack_require__("5XNM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_invoice_requests_store__ = __webpack_require__("E0LF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_notifications_store__ = __webpack_require__("yzBb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_auth_store__ = __webpack_require__("xrnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_follow_up_store__ = __webpack_require__("ODZb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__app_tours_store__ = __webpack_require__("CJr+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__app_profile_store__ = __webpack_require__("ZV33");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__app_activities_store__ = __webpack_require__("fMff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__app_payer_payment_notifications_store__ = __webpack_require__("fTGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__app_payer_invoice_upload_store__ = __webpack_require__("/8XT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__app_liquidation_requests_store__ = __webpack_require__("W2CW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__app_import_templates_store__ = __webpack_require__("4zUY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__app_tokens_store__ = __webpack_require__("1+PW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__app_operations_store__ = __webpack_require__("NmA5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__app_manager_invoices_store__ = __webpack_require__("xlNt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__app_switch_users_store__ = __webpack_require__("PQKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__app_funds_store__ = __webpack_require__("pHr1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__app_tenant_representatives_store__ = __webpack_require__("pfjc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__app_payer_assignors_store__ = __webpack_require__("JcNH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__app_contacts_store__ = __webpack_require__("v3qv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__app_abc_store__ = __webpack_require__("cUt3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__app_initial_load_store__ = __webpack_require__("BSzd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__services_worker__ = __webpack_require__("1gP2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__app_payer_assignment_requests_store__ = __webpack_require__("BVeW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__app_payer_contacts_store__ = __webpack_require__("3dTy");











































// payer stores




__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var modules = {
  users: __WEBPACK_IMPORTED_MODULE_6__app_user_store__["a" /* default */],
  settings: __WEBPACK_IMPORTED_MODULE_8__app_settings_store__["a" /* default */],
  clients: __WEBPACK_IMPORTED_MODULE_9__app_clients_store__["a" /* default */],
  payers: __WEBPACK_IMPORTED_MODULE_10__app_payers_store__["a" /* default */],
  assignors: __WEBPACK_IMPORTED_MODULE_11__app_assignors_store__["a" /* default */],
  importInvoices: __WEBPACK_IMPORTED_MODULE_12__app_import_invoices_store__["a" /* default */],
  permissions: __WEBPACK_IMPORTED_MODULE_7__app_permissions_store__["a" /* default */],
  campaigns: __WEBPACK_IMPORTED_MODULE_13__app_campaigns_store__["a" /* default */],
  invoices: __WEBPACK_IMPORTED_MODULE_14__app_invoices_store__["a" /* default */],
  assignmentRequest: __WEBPACK_IMPORTED_MODULE_15__app_assignment_request_store__["a" /* default */],
  antecipationRequest: __WEBPACK_IMPORTED_MODULE_16__app_antecipation_request_store__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_17__app_dashboard_store__["a" /* default */],
  steps: __WEBPACK_IMPORTED_MODULE_18__app_steps_store__["a" /* default */],
  banks: __WEBPACK_IMPORTED_MODULE_19__app_banks_store__["a" /* default */],
  invoiceRequests: __WEBPACK_IMPORTED_MODULE_20__app_invoice_requests_store__["a" /* default */],
  notifications: __WEBPACK_IMPORTED_MODULE_21__app_notifications_store__["a" /* default */],
  auth: __WEBPACK_IMPORTED_MODULE_22__app_auth_store__["a" /* default */],
  followUp: __WEBPACK_IMPORTED_MODULE_23__app_follow_up_store__["a" /* default */],
  tours: __WEBPACK_IMPORTED_MODULE_24__app_tours_store__["a" /* default */],
  profile: __WEBPACK_IMPORTED_MODULE_25__app_profile_store__["a" /* default */],
  activities: __WEBPACK_IMPORTED_MODULE_26__app_activities_store__["a" /* default */],
  payerPaymentNotifications: __WEBPACK_IMPORTED_MODULE_27__app_payer_payment_notifications_store__["a" /* default */],
  liquidationRequests: __WEBPACK_IMPORTED_MODULE_29__app_liquidation_requests_store__["a" /* default */],
  importTemplates: __WEBPACK_IMPORTED_MODULE_30__app_import_templates_store__["a" /* default */],
  tokens: __WEBPACK_IMPORTED_MODULE_31__app_tokens_store__["a" /* default */],
  operations: __WEBPACK_IMPORTED_MODULE_32__app_operations_store__["a" /* default */],
  managerInvoices: __WEBPACK_IMPORTED_MODULE_33__app_manager_invoices_store__["a" /* default */],
  switchUsers: __WEBPACK_IMPORTED_MODULE_34__app_switch_users_store__["a" /* default */],
  funds: __WEBPACK_IMPORTED_MODULE_35__app_funds_store__["a" /* default */],
  tenantRepresentatives: __WEBPACK_IMPORTED_MODULE_36__app_tenant_representatives_store__["a" /* default */],
  payerAssignors: __WEBPACK_IMPORTED_MODULE_37__app_payer_assignors_store__["a" /* default */],
  payerAssignmentRequest: __WEBPACK_IMPORTED_MODULE_42__app_payer_assignment_requests_store__["a" /* default */],
  payerContacts: __WEBPACK_IMPORTED_MODULE_43__app_payer_contacts_store__["a" /* default */],
  contacts: __WEBPACK_IMPORTED_MODULE_38__app_contacts_store__["a" /* default */],
  abc: __WEBPACK_IMPORTED_MODULE_39__app_abc_store__["a" /* default */],
  payerInvoiceUpload: __WEBPACK_IMPORTED_MODULE_28__app_payer_invoice_upload_store__["a" /* default */],
  initialLoad: __WEBPACK_IMPORTED_MODULE_40__app_initial_load_store__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
  modules: modules,
  strict: "production" !== 'production',
  state: {
    token: null,
    newCurrent: null
  },
  actions: {
    setNewCurrentUser: function setNewCurrentUser(_ref, obj) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      commit('SET_NEW_CURRENT', obj);
      dispatch('permissions/fetch');
    },
    setToken: function setToken(_ref2, obj) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit('SET_TOKEN', obj);
      dispatch('permissions/fetch');
    },
    removeToken: function removeToken(_ref3) {
      var commit = _ref3.commit;

      commit('REMOVE_TOKEN');
    },
    removeNewCurrent: function removeNewCurrent(_ref4) {
      var commit = _ref4.commit;

      commit('REMOVE_NEW_CURRENT');
    },
    watchJob: function watchJob(context, jobID) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  __WEBPACK_IMPORTED_MODULE_41__services_worker__["a" /* default */].jobStatus(jobID).then(function (response) {
                    resolve(response);
                  }).catch(function (err) {
                    reject(err);
                  });
                }));

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, obj) {
      state.token = obj.token;
    },
    REMOVE_TOKEN: function REMOVE_TOKEN(state) {
      state.token = null;
    },
    SET_NEW_CURRENT: function SET_NEW_CURRENT(state, obj) {
      state.newCurrent = obj;
    },
    REMOVE_NEW_CURRENT: function REMOVE_NEW_CURRENT(state) {
      state.newCurrent = null;
    }
  },
  getters: {
    current_user: function current_user(state) {
      var newCurrent = state.newCurrent;

      if (newCurrent != null) {
        return newCurrent;
      } else {
        var token = state.token;

        if (token != null) {
          var decoded = __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default()(token);
          return decoded;
        }
        return {};
      }
    },
    token: function token(state) {
      return state.token;
    },
    newCurrent: function newCurrent(state) {
      return state.newCurrent;
    },
    isAdminUser: function isAdminUser(state) {
      var token = state.token;

      if (token != null) {
        var decoded = __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default()(token);
        return decoded.user_type === 'admin_user';
      }
      return false;
    }
  }
}));

/***/ }),

/***/ "ItDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var invoicesSelected = {
  total_size: 0,
  total: '0,00',
  net_total: '0,00',
  invoices: [],
  errors: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  invoicesTotal: {
    total_size: 0,
    total: '0,00',
    total_liquid: '0,00'
  },
  initialInvoicesSelected: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, invoicesSelected),
  invoicesSelected: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, invoicesSelected),
  taxCommission: {
    tax: '0,00',
    commission: '0'
  }
});

/***/ }),

/***/ "J2X2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Mailer = function () {
  function Mailer() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Mailer);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Mailer, [{
    key: 'resendWelcomeEmail',
    value: function resendWelcomeEmail(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/assignors/welcome/' + id);
    }
  }, {
    key: 'payerSendWelcomeEmail',
    value: function payerSendWelcomeEmail(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('payer_send_welcome/' + id);
    }
  }, {
    key: 'templates',
    value: function templates() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/mail_templates/list');
    }
  }]);

  return Mailer;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Mailer());

/***/ }),

/***/ "JBbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var errors = {
  submit_user: []
};
/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  permissions: [],
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors)
});

/***/ }),

/***/ "JCkB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ActivityIndex = function ActivityIndex() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, "lMqn"));
};
var Refused = function Refused() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, "iFl6"));
};
var Cashier = function Cashier() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, "avjF"));
};

var CampaignIndex = function CampaignIndex() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "sOnw"));
};
var CampaignNew = function CampaignNew() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, "VaCR"));
};
var CampaignEdit = function CampaignEdit() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, "kWGf"));
};
var CampaignShow = function CampaignShow() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, "i0Cz"));
};

var SettingsIndex = function SettingsIndex() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, "CHVw"));
};
var SettingsFormLayout = function SettingsFormLayout() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, "KxoG"));
};

var InitialLoad = function InitialLoad() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, "PZCh"));
};

var LiquidationRequestsIndex = function LiquidationRequestsIndex() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, "Fvpv"));
};
var LiquidationRequestsNew = function LiquidationRequestsNew() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "bmp+"));
};
var LiquidationRequestsList = function LiquidationRequestsList() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, "PN6W"));
};

var OperationIndex = function OperationIndex() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "crLk"));
};
var OperationNew = function OperationNew() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "hVaG"));
};

var PayerPaymentIndex = function PayerPaymentIndex() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "vxuZ"));
};

var ContactIndex = function ContactIndex() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "P8nl"));
};

var ManagerInvoiceslist = function ManagerInvoiceslist() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "Hi+C"));
};
var ManagerInvoicesEdit = function ManagerInvoicesEdit() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, "CmjH"));
};
var ManagerInvoicesDocs = function ManagerInvoicesDocs() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "65z4"));
};

var ManagerInvoicesCompletedlist = function ManagerInvoicesCompletedlist() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "R5YW"));
};

var InvoiceWithDocumentslist = function InvoiceWithDocumentslist() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "VjKY"));
};
var InvoiceWithDocumentsEdit = function InvoiceWithDocumentsEdit() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, "Lflk"));
};
var InvoiceWithDocumentsDocs = function InvoiceWithDocumentsDocs() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "9FRn"));
};

var FundsIndex = function FundsIndex() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "C0zI"));
};
// const FundsNew = () => import('./pages/funds/new')
var FundsFormInfos = function FundsFormInfos() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, "O02p"));
};
var FundsListActivities = function FundsListActivities() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, "bHv5"));
};
var FundsListPayers = function FundsListPayers() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, "KblI"));
};
var FundsEdit = function FundsEdit() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, "ZSM4"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/management/activities/:id?',
  component: ActivityIndex,
  meta: { requiresAuth: true },
  children: [{
    path: '',
    name: 'activities.index',
    component: Cashier,
    meta: { requiresAuth: true }
  }, {
    path: 'refused',
    name: 'activities.refused',
    component: Refused,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/management/campaigns',
  name: 'campaigns.index',
  component: CampaignIndex,
  meta: { requiresAuth: true }
}, {
  path: '/management/campaigns/new',
  name: 'campaigns.new',
  component: CampaignNew,
  meta: { requiresAuth: true }
}, {
  path: '/management/campaigns/edit/:id',
  name: 'campaigns.edit',
  component: CampaignEdit,
  meta: { requiresAuth: true }
}, {
  path: '/management/campaigns/show/:id',
  name: 'campaigns.show',
  component: CampaignShow,
  meta: { requiresAuth: true }
}, {
  path: '/management/settings',
  component: SettingsIndex,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'settings.index',
    component: SettingsFormLayout,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/management/initial-load',
  component: InitialLoad,
  name: 'initial_load.index',
  meta: { requiresAuth: true }
}, {
  path: '/management/liquidation_requests',
  component: LiquidationRequestsIndex,
  meta: { requiresAuth: true },
  children: [{
    path: '',
    name: 'liquidation_requests.index',
    component: LiquidationRequestsNew,
    meta: { requiresAuth: true }
  }, {
    path: 'list',
    name: 'liquidation_requests.list',
    component: LiquidationRequestsList,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/management/operations',
  component: OperationIndex,
  meta: { requiresAuth: true },
  name: 'operations.index'
}, {
  path: '/management/operations/new',
  component: OperationNew,
  meta: { requiresAuth: true },
  name: 'operations.new'
}, {
  path: '/management/payer_payment_notifications',
  name: 'payer_payment_notifications.index',
  component: PayerPaymentIndex,
  meta: { requiresAuth: true }
}, {
  path: '/management/contacts',
  name: 'contacts.index',
  component: ContactIndex,
  meta: { requiresAuth: true }
}, {
  path: '/management/manager_invoice/completed',
  name: 'manager_invoices_completed.index',
  component: ManagerInvoicesCompletedlist,
  meta: { requiresAuth: true }
}, {
  path: '/management/manager_invoices',
  name: 'manager_invoices.index',
  component: ManagerInvoiceslist,
  meta: { requiresAuth: true }
}, {
  path: '/management/manager_invoices/edit/:id',
  component: ManagerInvoicesEdit,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'manager_invoices.edit.docs',
    component: ManagerInvoicesDocs,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/management/invoices_with_documents',
  name: 'payer_invoice_upload.index',
  component: InvoiceWithDocumentslist,
  meta: { requiresAuth: true }
}, {
  path: 'edit/:id',
  component: InvoiceWithDocumentsEdit,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'invoice_upload.edit.docs',
    component: InvoiceWithDocumentsDocs,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/management/funds',
  name: 'funds.index',
  component: FundsIndex,
  meta: { requiresAuth: true }
},
// {
//   path: '/funds/new',
//   component: FundsNew,
//   meta: { requiresAuth: true },
//   children: [
//     {
//       path: '/',
//       name: 'funds.new.infos',
//       component: FundsFormInfos,
//       meta: { requiresAuth: true }
//     }
//   ]
// },
{
  path: '/management/funds/edit/:id',
  component: FundsEdit,
  meta: { requiresAuth: true },
  children: [{
    path: '',
    name: 'funds.edit.infos',
    component: FundsFormInfos,
    meta: { requiresAuth: true }
  }, {
    path: 'activities',
    name: 'funds.edit.activities',
    component: FundsListActivities,
    meta: { requiresAuth: true }
  }, {
    path: 'payers',
    name: 'funds.edit.payers',
    component: FundsListPayers,
    meta: { requiresAuth: true }
  }]
}]);

/***/ }),

/***/ "JFsd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Notifications = function () {
  function Notifications() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Notifications);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Notifications, [{
    key: 'unread',
    value: function unread() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/notifications/user_notifications/unread_notifications');
    }
  }, {
    key: 'markAllAsRead',
    value: function markAllAsRead() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('notifications/user_notifications/mark_all_as_read');
    }
  }, {
    key: 'markAsRead',
    value: function markAsRead(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('notifications/user_notifications/mark_as_read/' + id);
    }
  }]);

  return Notifications;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Notifications());

/***/ }),

/***/ "JTRQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var fund = {
  id: 0,
  cnpj: '',
  legal_name: '',
  label: '',
  asset_manager: '',
  status: '',
  code_originator: '',
  vortx_url: '',
  vortx_handshake: '',
  bank_code: '',
  ag: '',
  cc: '',
  ag_code: '',
  cc_code: ''
};

var errors = {
  infos: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  initialFund: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fund),
  fund: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fund),
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  list: []
});

/***/ }),

/***/ "JXHy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_settings__ = __webpack_require__("HE03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_tenant__ = __webpack_require__("2pMd");




var _this = this;




var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_settings__["a" /* default */].fetch().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var save = function save(_ref2, payload) {
  var commit = _ref2.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_settings__["a" /* default */].save(payload).then(function (response) {
      commit('SET_SYSTEM_SETTINGS', response.data);
      resolve(response.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};

var fetchBank = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_settings__["a" /* default */].bankAccount().then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchBank(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var loadSystemSettings = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_settings__["a" /* default */].load().then(function (response) {
                commit('SET_SYSTEM_SETTINGS', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function loadSystemSettings(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var resetTenant = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, payload) {
    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_tenant__["a" /* default */].reset(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function resetTenant(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();

var updateValues = function updateValues(_ref8, obj) {
  var commit = _ref8.commit;

  commit('SET_SYSTEM_SETTINGS', obj);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  save: save,
  fetchBank: fetchBank,
  loadSystemSettings: loadSystemSettings,
  updateValues: updateValues,
  resetTenant: resetTenant
});

/***/ }),

/***/ "JZv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_mixins_flux_control__ = __webpack_require__("PB+e");

var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "uQDs"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  name: 'dashboard.index',
  component: Dashboard,
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_mixins_flux_control__["a" /* isAssignorComplete */])(next);
  }
}]);

/***/ }),

/***/ "JcNH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("uyIQ");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "KLBP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var SET_EXAMPLE = function SET_EXAMPLE(state, payload) {
  state.example = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_EXAMPLE: SET_EXAMPLE
});

/***/ }),

/***/ "LIRi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}}),_vm._v(" "),_c('vue-page-transition',[_c('router-view')],1),_vm._v(" "),_c('notifications',{attrs:{"position":"top left"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LJl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__ = __webpack_require__("6pID");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchAssignmentRequestStatus = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__["a" /* default */].status().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchAssignmentRequestStatus(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var save = function save(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__["a" /* default */].save(payload).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  save: save,
  fetch: fetch,
  fetchAssignmentRequestStatus: fetchAssignmentRequestStatus
});

/***/ }),

/***/ "LptW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_payer_group__ = __webpack_require__("kr/u");




var _this = this;



var fetchPayerGroups = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer_group__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data.data);
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchPayerGroups(_x) {
    return _ref.apply(this, arguments);
  };
}();

var findPayerGroups = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, id) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer_group__["a" /* default */].get(id).then(function (response) {
                commit('SET_PAYER_GROUP', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function findPayerGroups(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var savePayerGroups = function savePayerGroups(_ref5, payload) {
  var commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
      var verb, payer_group, method;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              verb = payload.verb, payer_group = payload.payer_group;
              method = verb === 'put' ? 'update' : 'save';


              __WEBPACK_IMPORTED_MODULE_3__services_payer_group__["a" /* default */][method](payer_group).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS', error.response.data);
                reject(error);
              });

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }());
};

var updatePayerGroupsValues = function updatePayerGroupsValues(_ref7, payload) {
  var commit = _ref7.commit;

  commit('UPDATE_VALUES', payload);
};

var resetPayerGroupsStateErrors = function resetPayerGroupsStateErrors(_ref8) {
  var commit = _ref8.commit;

  commit('RESET_ERRORS');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchPayerGroups: fetchPayerGroups,
  findPayerGroups: findPayerGroups,
  savePayerGroups: savePayerGroups,
  updatePayerGroupsValues: updatePayerGroupsValues,
  resetPayerGroupsStateErrors: resetPayerGroupsStateErrors
});

/***/ }),

/***/ "MCOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("mCmB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("SfuW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("CRKO");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "MbCF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_payer__ = __webpack_require__("lBjf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mailer__ = __webpack_require__("J2X2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_documents__ = __webpack_require__("A7iJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_user__ = __webpack_require__("ye8Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__ = __webpack_require__("6Rbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_btg__ = __webpack_require__("PPva");




var _this = this;









var sendWelcomeMail = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_mailer__["a" /* default */].payerSendWelcomeEmail(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function sendWelcomeMail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetch = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3) {
    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data.data);
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetch(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var find = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].get(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function find(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var findCommit = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref6, id) {
    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].get(id).then(function (response) {
                          commit('SET_PAYER', response.data);
                          resolve(response);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this);
              }));

              return function (_x8, _x9) {
                return _ref7.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function findCommit(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchCurrentPayer = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref9) {
    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].getCurrent().then(function (response) {
                commit('SET_CURRENT', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function fetchCurrentPayer(_x10) {
    return _ref8.apply(this, arguments);
  };
}();

var findByToken = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(context, token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].findByToken(token).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context7.stop();
                    }
                  }
                }, _callee7, _this);
              }));

              return function (_x13, _x14) {
                return _ref11.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function findByToken(_x11, _x12) {
    return _ref10.apply(this, arguments);
  };
}();

var saveByToken = function saveByToken(context, obj) {
  var token = obj.token,
      user = obj.user;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_6__services_user__["a" /* default */].saveByToken(token, user).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });

            case 1:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this);
    }));

    return function (_x15, _x16) {
      return _ref12.apply(this, arguments);
    };
  }());
};

var save = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(_ref14, obj) {
    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(resolve, reject) {
                var verb, dataPayer, method;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        verb = obj.verb, dataPayer = obj.dataPayer;
                        method = verb === 'put' ? 'update' : 'save';


                        __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */][method](dataPayer).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          commit('SET_ERRORS', error.response.data);
                          reject(error);
                        });

                      case 3:
                      case 'end':
                        return _context10.stop();
                    }
                  }
                }, _callee10, _this);
              }));

              return function (_x19, _x20) {
                return _ref15.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this);
  }));

  return function save(_x17, _x18) {
    return _ref13.apply(this, arguments);
  };
}();

var sendDocs = function sendDocs(context, data) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_5__services_documents__["a" /* default */].sendPayerDocs(data).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_7__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this);
    }));

    return function (_x21, _x22) {
      return _ref16.apply(this, arguments);
    };
  }());
};

var fetchByList = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(_ref18) {
    var commit = _ref18.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].byCampaign().then(function (response) {
                commit('SET_LIST_TO_CAMPAIGN', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this);
  }));

  return function fetchByList(_x23) {
    return _ref17.apply(this, arguments);
  };
}();

var fetchFeeTerm = function () {
  var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(_ref20, payload) {
    var commit = _ref20.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_9__services_btg__["a" /* default */].feePerTerm(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this);
  }));

  return function fetchFeeTerm(_x24, _x25) {
    return _ref19.apply(this, arguments);
  };
}();

var feeTermDownload = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(_ref22, id) {
    var commit = _ref22.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_9__services_btg__["a" /* default */].feePerTermDowload(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this);
  }));

  return function feeTermDownload(_x26, _x27) {
    return _ref21.apply(this, arguments);
  };
}();

var feeTermUpload = function () {
  var _ref23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(_ref24, payload) {
    var commit = _ref24.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_9__services_btg__["a" /* default */].feePerTermUpload(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_7__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, _this);
  }));

  return function feeTermUpload(_x28, _x29) {
    return _ref23.apply(this, arguments);
  };
}();

var findAssignorsByPayer = function () {
  var _ref25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].getAssignors(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, _this);
  }));

  return function findAssignorsByPayer(_x30, _x31) {
    return _ref25.apply(this, arguments);
  };
}();

var fetchEmailTemplates = function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee18(context) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_mailer__["a" /* default */].templates().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, _this);
  }));

  return function fetchEmailTemplates(_x32) {
    return _ref26.apply(this, arguments);
  };
}();

var resetStatePayer = function resetStatePayer(_ref27) {
  var commit = _ref27.commit;

  commit('RESET_PAYER');
};

var resetStateErrors = function resetStateErrors(_ref28) {
  var commit = _ref28.commit;

  commit('RESET_ERRORS');
};

var updateValues = function updateValues(context, obj) {
  context.commit('UPDATE_VALUES', obj);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  fetchCurrentPayer: fetchCurrentPayer,
  fetchEmailTemplates: fetchEmailTemplates,
  find: find,
  findCommit: findCommit,
  findByToken: findByToken,
  saveByToken: saveByToken,
  sendWelcomeMail: sendWelcomeMail,
  save: save,
  sendDocs: sendDocs,
  resetStatePayer: resetStatePayer,
  resetStateErrors: resetStateErrors,
  updateValues: updateValues,
  fetchByList: fetchByList,
  findAssignorsByPayer: findAssignorsByPayer,
  fetchFeeTerm: fetchFeeTerm,
  feeTermUpload: feeTermUpload,
  feeTermDownload: feeTermDownload
});

/***/ }),

/***/ "N0uf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: []
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert__ = __webpack_require__("f1Fh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate__ = __webpack_require__("ESwS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_error_extractor__ = __webpack_require__("Vp0C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_error_extractor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_error_extractor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_metronic_input_template__ = __webpack_require__("0waH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notification__ = __webpack_require__("CLX7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask__ = __webpack_require__("hlPV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_events__ = __webpack_require__("EZrF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__ = __webpack_require__("6Rbp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_select2_component__ = __webpack_require__("EZfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect__ = __webpack_require__("RUzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_tour__ = __webpack_require__("pvO8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_tour___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_tour__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_page_transition__ = __webpack_require__("4U6a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_cool_select__ = __webpack_require__("v0BJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_cool_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_cool_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_currency_input__ = __webpack_require__("P6Co");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__the_container__ = __webpack_require__("+2pc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_scroll__ = __webpack_require__("agGj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_daterange_picker__ = __webpack_require__("cbJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_daterange_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue2_daterange_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_v_clipboard__ = __webpack_require__("DOD7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_v_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_v_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_json_excel__ = __webpack_require__("+Rp4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_signal__ = __webpack_require__("0lA/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__appsignal_vue__ = __webpack_require__("qvmA");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.errorHandler = Object(__WEBPACK_IMPORTED_MODULE_24__appsignal_vue__["a" /* errorHandler */])(__WEBPACK_IMPORTED_MODULE_23__utils_signal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_vue__["default"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_bootstrap_vue__["a" /* BootstrapVue */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_bootstrap_vue__["b" /* BootstrapVueIcons */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

window.$ = window.jQuery = __webpack_require__("7t+N");
__webpack_require__("K3J8");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_event_bus__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_the_mask___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_sweetalert___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_tour___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_page_transition__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__("8AgW"));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate_error_extractor___default.a, {
  template: __WEBPACK_IMPORTED_MODULE_4__utils_metronic_input_template__["a" /* default */],
  messages: {
    required: '{attribute} não pode ser vazio',
    email: '{attribute} em formato inválido',
    minLength: '{attribute} deve conter no mínimo {min} caractéres',
    sameAsPassword: '{attribute} deve ser igual a senha'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_cool_select___default.a, {
  theme: 'bootstrap'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_v_clipboard___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_currency_input__["a" /* default */], {
  globalOptions: {
    currency: 'BRL',
    currencyDisplay: 'symbol',
    precision: 2,
    distractionFree: false,
    autoDecimalMode: true
  },
  componentName: 'Money' // Replace old v-money component
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Select2', __WEBPACK_IMPORTED_MODULE_9_v_select2_component__["a" /* default */]);
__webpack_require__("iq7p");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('DateRangePicker', __WEBPACK_IMPORTED_MODULE_19_vue2_daterange_picker___default.a);
__webpack_require__("wmAf");

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Multiselect', __WEBPACK_IMPORTED_MODULE_10_vue_multiselect___default.a);
__webpack_require__("tLvy");
/* eslint-disable no-new */

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('DownloadExcel', __WEBPACK_IMPORTED_MODULE_21_vue_json_excel__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('scroll', __WEBPACK_IMPORTED_MODULE_18__directives_scroll__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_16__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_17__store__["a" /* default */],
  template: '<TheContainer/>',
  components: { TheContainer: __WEBPACK_IMPORTED_MODULE_15__the_container__["a" /* default */] }
});

/***/ }),

/***/ "NRSB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: []
});

/***/ }),

/***/ "NmA5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("kopn");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "ODZb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("8tJU");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "OmWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_user__ = __webpack_require__("ye8Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_auth__ = __webpack_require__("4zFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_permissions__ = __webpack_require__("9GhJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_localforage__);




var _this = this;






var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchUser = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].get(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchUser(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchPermissions = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (payload) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt('return');

          case 2:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_5__services_permissions__["a" /* default */].fetchByType(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function fetchPermissions(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var saveUser = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref6, payload) {
    var commit = _ref6.commit;
    var verb, user, method;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            verb = payload.verb, user = payload.user;
            method = verb === 'put' ? 'update' : 'save';
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */][method](user).then(function (response) {
                commit('RESET_ERRORS');
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS', { submit_user: error.response.data });
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function saveUser(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

var saveUserAvatar = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref8, payload) {
    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_user__["a" /* default */].saveAvatar(payload).then(function (response) {
                commit('RESET_ERRORS');
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS', { submit_user: error.response.data });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function saveUserAvatar(_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();

var login = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref10, payload) {
    var commit = _ref10.commit;
    var email, password;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            email = payload.email.trim().toLowerCase();
            password = payload.password.trim();
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].login(email, password).then(function (response) {
                var jwt = response.data.jwt;

                __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('token', jwt).then(function (jwt) {
                  commit('SET_TOKEN', jwt, { root: true });
                });
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 3:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function login(_x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();

var redirectLogin = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref12, token) {
    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_auth__["a" /* default */].redirectLogin(token).then(function (response) {
                var data = response.data;
                __WEBPACK_IMPORTED_MODULE_6_localforage___default.a.setItem('token', data[0]['token']).then(function (jwt) {
                  commit('SET_TOKEN', jwt, { root: true });
                });
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function redirectLogin(_x12, _x13) {
    return _ref11.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  fetchUser: fetchUser,
  fetchPermissions: fetchPermissions,
  saveUser: saveUser,
  login: login,
  redirectLogin: redirectLogin,
  saveUserAvatar: saveUserAvatar
});

/***/ }),

/***/ "P9hr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_import__ = __webpack_require__("qwtf");




var _this = this;



var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_import__["a" /* default */].templates().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var findTemplate = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_import__["a" /* default */].findTemplate(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function findTemplate(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  findTemplate: findTemplate
});

/***/ }),

/***/ "PB+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAssignorComplete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__("IcnI");


var isAssignorComplete = function isAssignorComplete(next) {
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */]._actions['profile/fetch'][0]().then(function () {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.current_user.user_type !== 'assignor_user' || __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.profile.current.assignor && (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.profile.current.assignor['complete?'] || __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.profile.current.assignor['available_invoices?'])) {
      next();
    } else {
      next({ name: 'steps.index' });
    }
  });
};

/***/ }),

/***/ "PPva":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Btg = function () {
  function Btg() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Btg);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Btg, [{
    key: 'feePerTerm',
    value: function feePerTerm(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/btg/configurations?fund_id=' + payload.fund_id + '&payer_id=' + payload.payer_id);
    }
  }, {
    key: 'feePerTermDowload',
    value: function feePerTermDowload(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/btg/configurations/download_file?id=' + id);
    }
  }, {
    key: 'feePerTermUpload',
    value: function feePerTermUpload(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/btg/configurations/', payload);
    }
  }]);

  return Btg;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Btg());

/***/ }),

/***/ "PQKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("kR3n");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "Q5jr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("4sDf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("V2Mf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("LJl9");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "QjFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_payer__ = __webpack_require__("lBjf");




var _this = this;



var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].paymentNotifications(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var sendMail = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_payer__["a" /* default */].sendEmail(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function sendMail(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  sendMail: sendMail
});

/***/ }),

/***/ "QrMF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var errors = {
  docs: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors)
});

/***/ }),

/***/ "RzKu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http_portal__ = __webpack_require__("0/xT");




var Occurrence = function () {
  function Occurrence() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Occurrence);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Occurrence, [{
    key: 'nestedOccurrenceById',
    value: function nestedOccurrenceById(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http_portal__["a" /* default */].get('/private/api/v1/ocurrences/' + id);
    }
  }]);

  return Occurrence;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Occurrence());

/***/ }),

/***/ "S0HV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_profile__ = __webpack_require__("h9qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_localforage__);




var _this = this;




var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_profile__["a" /* default */].permissions().then(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.setItem('current_permissions', response.data);

                        case 2:
                          commit('SET_LIST', response.data);
                          resolve(response.data);

                        case 4:
                        case 'end':
                          return _context.stop();
                      }
                    }
                  }, _callee, _this);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }()).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch
});

/***/ }),

/***/ "SfuW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



var SET_LIST = function SET_LIST(state, obj) {
  state.list = obj;
};

var SET_LIST_AVAILABLE = function SET_LIST_AVAILABLE(state, obj) {
  state.listAvaliable = obj;
};

var SET_INFORMATION = function SET_INFORMATION(state, obj) {
  state.informationCampaign = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, obj, {
    operation: obj.infos.operations.reduce(function (defaultObj, opt) {
      if (obj.fund_id === opt.fund_id) {
        defaultObj = opt;
      }
      return defaultObj;
    }, {}),
    errors: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(obj.infos.errors).reduce(function (errors, error) {
      errors = errors.concat(error);
      return errors;
    }, [])
  });
};

var RESET_INFORMATION = function RESET_INFORMATION(state) {
  state.informationCampaign = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.initInformationCampaign));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_LIST_AVAILABLE: SET_LIST_AVAILABLE,
  SET_INFORMATION: SET_INFORMATION,
  RESET_INFORMATION: RESET_INFORMATION
});

/***/ }),

/***/ "T80C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_notifications__ = __webpack_require__("JFsd");




var _this = this;



var fetchNotifications = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].unread().then(function (response) {
                commit('SET_NOTIFICATIONS', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchNotifications(_x) {
    return _ref.apply(this, arguments);
  };
}();

var markAllAsRead = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].markAllAsRead().then(function (response) {
                commit('SET_NOTIFICATIONS', []);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function markAllAsRead(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var markAsRead = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, id) {
    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_notifications__["a" /* default */].markAsRead().then(function (response) {
                commit('REMOVE_NOTIFICATION', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function markAsRead(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchNotifications: fetchNotifications,
  markAllAsRead: markAllAsRead,
  markAsRead: markAsRead
});

/***/ }),

/***/ "TFLl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = function index() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "axfN"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/payer_assignors',
  name: 'payers.assignments',
  component: index,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "TIfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAccessToken;
/* unused harmony export isLoggedIn */
/* harmony export (immutable) */ __webpack_exports__["b"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__("IcnI");




// import http from '@/services/http'



// import { mapActions } from 'vuex'

var ACCESS_TOKEN_KEY = 'token';

function getAccessToken() {
  return __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.getItem(ACCESS_TOKEN_KEY);
}

var isLoggedIn = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var accessToken;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.getItem(ACCESS_TOKEN_KEY);

          case 2:
            accessToken = _context.sent;
            return _context.abrupt('return', !!accessToken && !isTokenExpired(accessToken));

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function isLoggedIn() {
    return _ref.apply(this, arguments);
  };
}();

function logout() {
  __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem('new_current_user').then(function () {
    __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('removeNewCurrent', { root: true });
  });
  __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem(ACCESS_TOKEN_KEY).then(function () {
    __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem('new_current_user').then(function () {
      __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('removeNewCurrent', { root: true });
      __WEBPACK_IMPORTED_MODULE_4_localforage___default.a.removeItem('current_permissions').then(function () {
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ name: 'auth.login' });
      });
    });
  });
}

// mapActions(['setToken'])
//
// export async function login (email, password) {
//   const response = await http.post('/user_token', { auth: { email, password } })
//   const { jwt } = response.data
//
//   localforage.setItem('token', jwt).then((jwt) => {
//     debugger
//     this.setToken({ token: jwt })
//     router.push({ name: 'dashboard.index' })
//   })
// }

function getTokenExpirationDate(encodedToken) {
  var token = __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(encodedToken);
  if (!token.exp) {
    return null;
  }

  var date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  var expirationDate = getTokenExpirationDate(token);
  return expirationDate < new Date();
}

/***/ }),

/***/ "TOWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var SET_PERMISSIONS = function SET_PERMISSIONS(state, payload) {
  state.permissions = payload;
};

var SET_ERRORS = function SET_ERRORS(state, payload) {
  state.errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload);
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.initialErrors);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_PERMISSIONS: SET_PERMISSIONS,
  SET_ERRORS: SET_ERRORS,
  RESET_ERRORS: RESET_ERRORS
});

/***/ }),

/***/ "TqjL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  example: {}
});

/***/ }),

/***/ "UHJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "UUdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProfileIndex = function ProfileIndex() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, "f60/"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/my-profile',
  name: 'profile.index',
  component: ProfileIndex,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "UgXF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = function index() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "l4/I"));
};
var detail = function detail() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "O/jp"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/proposals',
  name: 'proposals.index',
  component: index,
  meta: { requiresAuth: true }
}, {
  path: '/proposals/:id/details',
  name: 'proposals.detail',
  component: detail,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "V2Mf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, obj) {
  state.list = obj;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "V6bW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_funds__ = __webpack_require__("ukTl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_http__ = __webpack_require__("+bCW");




var _this = this;




var find = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_funds__["a" /* default */].get(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function find(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var findCommit = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref3, id) {
    var commit = _ref3.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_funds__["a" /* default */].get(id).then(function (response) {
                commit('SET_FUND', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function findCommit(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var save = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5, payload) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                var verb, dataFund, method;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        verb = payload.verb, dataFund = payload.dataFund;
                        method = verb === 'put' ? 'update' : 'save';


                        __WEBPACK_IMPORTED_MODULE_3__services_funds__["a" /* default */][method](dataFund).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          commit('SET_ERRORS', error.response.data);
                          reject(error);
                        });

                      case 3:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }));

              return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function save(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var fetch = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref8) {
    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_funds__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function fetch(_x9) {
    return _ref7.apply(this, arguments);
  };
}();

var fundsByPayer = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref10, id) {
    var commit = _ref10.commit;
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return __WEBPACK_IMPORTED_MODULE_4__services_http__["a" /* default */].get('/funds/by_payer_id/' + id);

          case 2:
            response = _context6.sent;

            if (response != null) {
              commit('SET_LIST', response.data);
            }

          case 4:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function fundsByPayer(_x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();

var fundsAvailableToAssignorByPayerCnpj = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref12, obj) {
    var commit = _ref12.commit;
    var response, funds;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return __WEBPACK_IMPORTED_MODULE_4__services_http__["a" /* default */].get('/assignors/' + obj.assignorId + '/funds_available/by_payer_cnpj?payer_cnpj=' + obj.payerCnpj);

          case 2:
            response = _context7.sent;

            if (response != null) {
              funds = response.data.map(function (fund) {
                return { id: fund.id, text: fund.label };
              });

              commit('SET_LIST', funds);
            }

          case 4:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function fundsAvailableToAssignorByPayerCnpj(_x12, _x13) {
    return _ref11.apply(this, arguments);
  };
}();

var resetState = function resetState(_ref13) {
  var commit = _ref13.commit;

  commit('RESET_STATE');
};

var resetStateErrors = function resetStateErrors(_ref14) {
  var commit = _ref14.commit;

  commit('RESET_ERRORS');
};

var updateValues = function updateValues(_ref15, payload) {
  var commit = _ref15.commit;

  commit('UPDATE_VALUES', payload);
};

var resetListFund = function resetListFund(_ref16) {
  var commit = _ref16.commit;

  commit('RESET_LIST');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  find: find,
  findCommit: findCommit,
  save: save,
  resetState: resetState,
  resetStateErrors: resetStateErrors,
  updateValues: updateValues,
  fetch: fetch,
  resetListFund: resetListFund,
  fundsByPayer: fundsByPayer,
  fundsAvailableToAssignorByPayerCnpj: fundsAvailableToAssignorByPayerCnpj
});

/***/ }),

/***/ "W2CW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("IRd5");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "W7+p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Bank = function () {
  function Bank() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Bank);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Bank, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/banks');
    }
  }, {
    key: 'fetchByAssignor',
    value: function fetchByAssignor(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/banks/by_assignor/' + id + '/');
    }
  }]);

  return Bank;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Bank());

/***/ }),

/***/ "Wr/Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "WvpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_http__ = __webpack_require__("+bCW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var changeStatusDoc = function changeStatusDoc(_ref, data) {
  var commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              response = __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].put('/manage_invoice_documents/change_status', data);

              response.then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS_DOCS', error.response.data);
                reject(error);
              });

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }());
};

var changeSituationDoc = function changeSituationDoc(_ref3) {
  var commit = _ref3.commit;
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { document_id: '', code: '' };

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              response = __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].put('/manage_invoice_documents/change_situation', obj);

              response.then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }());
};

var sendDocs = function sendDocs(_ref5, data) {
  var commit = _ref5.commit;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              response = __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].post('/manage_invoice_documents/new', data);

              response.then(function (response) {
                commit('RESET_ERRORS_DOCS');
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_ERRORS_DOCS', error.response.data);
                reject(error);
              });

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }());
};

var resetErrors = function resetErrors(_ref7) {
  var commit = _ref7.commit;

  commit('RESET_ERRORS_DOCS');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  changeStatusDoc: changeStatusDoc,
  changeSituationDoc: changeSituationDoc,
  sendDocs: sendDocs,
  resetErrors: resetErrors
});

/***/ }),

/***/ "WzqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FollowUp = function FollowUp() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, "8K+9"));
};
var PreviewAssignors = function PreviewAssignors() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, "awwO"));
};
var PreviewAssignments = function PreviewAssignments() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, "D/0b"));
};

var LimitIndex = function LimitIndex() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, "Y4Ak"));
};
var LimitAssignors = function LimitAssignors() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "pQff"));
};
var LimitPayers = function LimitPayers() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "6cdy"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/follow_up',
  component: FollowUp,
  meta: { requiresAuth: true },
  children: [{
    path: 'assignors',
    name: 'preview.assignors',
    component: PreviewAssignors,
    meta: { requiresAuth: true }
  }, {
    path: 'assignments',
    name: 'preview.assignments',
    component: PreviewAssignments,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/follow_up/limits',
  component: LimitIndex,
  meta: { requiresAuth: true },
  children: [{
    path: 'payers',
    name: 'limits.payers',
    component: LimitPayers,
    meta: { requiresAuth: true }
  }, {
    path: 'assignors',
    name: 'limits.assignors',
    component: LimitAssignors,
    meta: { requiresAuth: true }
  }]
}]);

/***/ }),

/***/ "X+hB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XB3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var payer = {
  id: 0,
  payer_group_id: '',
  status: '',
  cnpj: '',
  fantasy_name: '',
  legal_name: '',
  uf: '',
  city: '',
  cep: '',
  neighborhood: '',
  address: '',
  address_number: '',
  website: '',
  min_days: 15,
  max_days: 390,
  min_value: 5000,
  rebate: null,
  internal_tax: 1.90,
  internal_commission: 1.80,
  new_limit: 0,
  assignors_type: 'invoice',
  payer_contacts: [],
  payer_contacts_attributes: [],
  limits: [],
  last_limits: [],
  limits_attributes: [],
  import_template_ids: [],
  mail_templates: [],
  mail_template_welcome_id: null,
  mail_template_available_invoice_id: null,
  mail_template_partnership_id: null,
  rescue_availability_start_time: null,
  rescue_availability_end_time: null,
  fund_id: null,
  funds: [],
  payer_funds: [],
  payer_funds_attributes: [],
  branch_offices: [],
  branch_offices_attributes: []
};

var errors = {
  infos: [],
  contact: [],
  importRule: [],
  taxLimit: [],
  docs: [],
  funds: [],
  branch_offices: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  initialPayer: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payer),
  payer: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payer),
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  list: [],
  current: {
    limit_total: 0,
    limit_used: 0
  },
  listToCampaign: []
});

/***/ }),

/***/ "XLAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http_portal__ = __webpack_require__("0/xT");




var AntecipationRequest = function () {
  function AntecipationRequest() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AntecipationRequest);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AntecipationRequest, [{
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http_portal__["a" /* default */].get('/private/api/antecipation_request/' + id);
    }
  }]);

  return AntecipationRequest;
}();

/* harmony default export */ __webpack_exports__["a"] = (new AntecipationRequest());

/***/ }),

/***/ "Y1Fv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth__ = __webpack_require__("4zFs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_settings__ = __webpack_require__("HE03");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;






var resetEmail = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, email) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].resetEmail(email).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function resetEmail(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var validate = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].resetEmail(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function validate(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var getSystemSettings = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref4) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_settings__["a" /* default */].load().then(function (response) {
                commit('SET_SYSTEM_SETTINGS', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getSystemSettings(_x5) {
    return _ref3.apply(this, arguments);
  };
}();

var changePassword = function changePassword(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].changePassword(payload).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

var acceptTerms = function acceptTerms(context) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3__services_auth__["a" /* default */].acceptTerms().then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  resetEmail: resetEmail,
  validate: validate,
  changePassword: changePassword,
  getSystemSettings: getSystemSettings,
  acceptTerms: acceptTerms
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__app_auth_routes__ = __webpack_require__("nbDU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__app_dashboard_routes__ = __webpack_require__("JZv+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__app_extract_routes__ = __webpack_require__("epAM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__app_proposals_routes__ = __webpack_require__("UgXF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__app_user_routes__ = __webpack_require__("pz2A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__app_profile_routes__ = __webpack_require__("UUdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__app_clients_routes__ = __webpack_require__("qYPm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_import_invoices_routes__ = __webpack_require__("2Uks");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__app_steps_routes__ = __webpack_require__("cBpM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_assignment_request_routes__ = __webpack_require__("+zLg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__app_antecipation_request_routes__ = __webpack_require__("CIt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_follow_up_routes__ = __webpack_require__("WzqM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__app_assignments_routes__ = __webpack_require__("FLY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__app_management_routes__ = __webpack_require__("JCkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__app_tokens_routes__ = __webpack_require__("uSdp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__app_confirmation_routes__ = __webpack_require__("zenJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__app_payer_assignors_routes__ = __webpack_require__("TFLl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__app_abc_routes__ = __webpack_require__("k/BA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__app_payer_assignment_requests_routes__ = __webpack_require__("HExQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__app_payer_contacts_routes__ = __webpack_require__("cXLL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__utils_auth__ = __webpack_require__("TIfe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_localforage__);




var _this = this;























// routes payer







var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, "5ih6"));
};

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_4_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__app_profile_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__app_auth_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__app_dashboard_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__app_proposals_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__app_user_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__app_clients_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__app_import_invoices_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__app_steps_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__app_assignment_request_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__app_follow_up_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__app_assignments_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__app_management_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_19__app_tokens_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__app_confirmation_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__app_payer_assignors_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__app_payer_assignment_requests_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_24__app_payer_contacts_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__app_abc_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__app_antecipation_request_routes__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7__app_extract_routes__["a" /* default */]), [{
    path: '*',
    name: 'errors.not_found',
    component: NotFound,
    meta: { requiresAuth: true }
  }]),
  scrollBehavior: function scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

var checkAuth = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var token;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Object(__WEBPACK_IMPORTED_MODULE_26__utils_auth__["a" /* getAccessToken */])();

          case 2:
            token = _context.sent;

            __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].dispatch('setToken', { token: token });

            if (token === null) {
              next({ name: 'auth.login' });
            }
            next();

          case 6:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function checkAuth(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var checkPermission = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(to, from, next) {
    var userPermissions, routePermissions, storedPermissions;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            userPermissions = __WEBPACK_IMPORTED_MODULE_25__store__["a" /* default */].state.permissions.list;
            routePermissions = to.meta.permissions;
            _context2.next = 4;
            return __WEBPACK_IMPORTED_MODULE_27_localforage___default.a.getItem('current_permissions');

          case 4:
            storedPermissions = _context2.sent;

            if (userPermissions.some(function (role) {
              return routePermissions.includes(role);
            }) || storedPermissions.some(function (role) {
              return routePermissions.includes(role);
            })) {
              next();
            } else {
              next({ name: 'dashboard.index' });
            }

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function checkPermission(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

router.beforeEach(function (to, from, next) {
  if (!to.meta.requiresAuth) {
    next();
  } else {
    checkAuth(to, from, next);
    if (to.meta.permissions) {
      checkPermission(to, from, next);
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YzSA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("JBbb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("TOWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("OmWo");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "ZV33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("sCw1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("z1BS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("091e");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "Zo+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var defaulDaysFilter = 90;

var summaryDatatable = {
  total_invoices: 0,
  total_occurrences: 0,
  total_amount: 0,
  total_available_amount: 0,
  total_payment_amount: 0,
  total_anticipated_amount: 0,
  total_invoices_status_quitada: 0,
  total_invoices_status_aberto: 0,
  total_invoices_status_antecipado: 0,
  days_filter: defaulDaysFilter,
  cnpjs: [],
  cnpjs_payers: [],
  invoice_number: '',
  scheduled_date_init: '',
  scheduled_date_end: '',
  payment_date_init: '',
  payment_date_end: '',
  status: '',
  local_type: '',
  paramsQuery: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
  corretor: {
    avalaible: 0,
    pending: 0,
    total: 0,
    percents: {
      avalaible: 0,
      pending: 0
    }
  },
  dashboard: {},
  dashboardSummary: [{
    name: 'Indisponível',
    y: 0,
    color: '#00c5dc'
  }, {
    name: 'Em resgate',
    y: 0,
    color: '#716aca'
  }, {
    name: 'A resgatar',
    y: 0,
    color: '#ffb822'
  }],
  summaryDatatable: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, summaryDatatable)
});

/***/ }),

/***/ "agGj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: function inserted(el, binding) {
    var f = function f(evt) {
      if (binding.value(evt, el)) {
        el.removeEventListener('scroll', f);
      }
    };
    el.addEventListener('scroll', f);
  }
});

/***/ }),

/***/ "aja2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_activities__ = __webpack_require__("gTDF");




var _this = this;



var fetchBalance = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_activities__["a" /* default */].get(id).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchBalance(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var save = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_activities__["a" /* default */].create(payload).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function save(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  save: save,
  fetchBalance: fetchBalance
});

/***/ }),

/***/ "bDg4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payer_groups_state__ = __webpack_require__("fXND");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payer_groups_mutations__ = __webpack_require__("zzWR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payer_groups_actions__ = __webpack_require__("LptW");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  modules: {
    payerGroups: {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_0__payer_groups_state__["a" /* default */],
      mutations: __WEBPACK_IMPORTED_MODULE_1__payer_groups_mutations__["a" /* default */],
      actions: __WEBPACK_IMPORTED_MODULE_2__payer_groups_actions__["a" /* default */]
    }
  }
});

/***/ }),

/***/ "cBpM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index_js__ = __webpack_require__("IcnI");



var _this = this;



var index = function index() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, "XGok"));
};
var ComplementAssignor = function ComplementAssignor() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, "PLQ2"));
};
var assignor = function assignor() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, "SoMA"));
};
var representative = function representative() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, "XMSe"));
};
var BankAccount = function BankAccount() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, "nJdK"));
};
var docs = function docs() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, "SZen"));
};
var success = function success() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, "/I5C"));
};
var sended = function sended() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, "3x3D"));
};

var validateStatusAssignor = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var current;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */]._actions['profile/fetch'][0]();

          case 2:
            current = __WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].state.profile.current;


            if (current.assignor.is_progress) {
              next({ name: 'steps.sended' });
            } else {
              next();
            }

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function validateStatusAssignor(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/steps/index',
  name: 'steps.index',
  component: index,
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    return validateStatusAssignor(to, from, next);
  }
}, {
  path: '/steps/sended',
  name: 'steps.sended',
  component: sended,
  meta: { requiresAuth: true }
}, {
  path: '/steps/complete_assignor',
  component: ComplementAssignor,
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    return validateStatusAssignor(to, from, next);
  },
  children: [{
    path: '/',
    name: 'steps.complete_assignor.assignor',
    component: assignor,
    meta: { requiresAuth: true }
  }, {
    path: 'representative',
    name: 'steps.complete_assignor.representative',
    component: representative,
    meta: { requiresAuth: true }
  }, {
    path: 'bank-account',
    name: 'steps.complete_assignor.bank-account',
    component: BankAccount,
    meta: { requiresAuth: true }
  }, {
    path: 'docs',
    name: 'steps.complete_assignor.docs',
    component: docs,
    meta: { requiresAuth: true }
  }, {
    path: 'success',
    name: 'steps.complete_assignor.success',
    component: success,
    meta: { requiresAuth: true }
  }]
}]);

/***/ }),

/***/ "cUt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("o3tJ");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "cXLL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var index = function index() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "NLBO"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/payer_contacts',
  name: 'payer.contacts',
  component: index,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "dUai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var assignor = {
  id: 0,
  vortx_assignor_integration_documents_status: 'not_sended',
  status: '',
  assignor_type: '',
  cnpj: '',
  fantasy_name: '',
  legal_name: '',
  uf: '',
  city: '',
  cep: '',
  neighborhood: '',
  address: '',
  address_number: '',
  email_nfse: '',
  contact_name: '',
  contact_phone: '',
  contact_cellphone: '',
  contact_email: '',
  website: '',
  min_days: '',
  max_days: '',
  min_value: '',
  internal_tax: '',
  internal_commission: '',
  new_limit: '',
  eligible: false,
  payer_ids: [],
  last_limits: [],
  limits_attributes: [],
  bank_accounts: [],
  bank_accounts_attributes: [],
  assignor_representatives: [],
  assignor_representatives_attributes: [],
  branch_offices: [],
  branch_offices_attributes: [],
  assignor_funds: [],
  assignor_funds_attributes: [],
  contacts: [],
  contacts_attributes: [],
  assignor_documentations: []
};

var errors = {
  infos: [],
  importRule: [],
  taxLimit: [],
  bankAccount: [],
  representative: [],
  docs: [],
  branch_offices: [],
  assignor: {},
  funds: [],
  import_assignors: [],
  contacts: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  initalAssignor: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, assignor),
  assignor: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, assignor),
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  list: [],
  current: {},
  contractTemplateOptions: []
});

/***/ }),

/***/ "egOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Token = function () {
  function Token() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Token);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Token, [{
    key: 'save',
    value: function save(tenantAuthenticationToken) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/tenant_authentication_tokens', { tenant_authentication_token: tenantAuthenticationToken });
    }
  }, {
    key: 'remove',
    value: function remove(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].delete('/tenant_authentication_tokens/' + id);
    }
  }]);

  return Token;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Token());

/***/ }),

/***/ "epAM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_mixins_flux_control__ = __webpack_require__("PB+e");


var PayerExtract = function PayerExtract() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "3LiV"));
};
var AdminExtract = function AdminExtract() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "y8S/"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/extract',
  name: 'dashboard.extract',
  component: PayerExtract,
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_mixins_flux_control__["a" /* isAssignorComplete */])(next);
  }
}, {
  path: '/admin_extract',
  name: 'dashboard.admin_extract',
  component: AdminExtract,
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_mixins_flux_control__["a" /* isAssignorComplete */])(next);
  }
}]);

/***/ }),

/***/ "fMff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("aja2");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "fTGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("GtEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("Wr/Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("QjFZ");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "fXND":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var errors = {
  infos: [],
  contact: [],
  importRule: [],
  taxLimit: [],
  docs: [],
  funds: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  errors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  initialErrors: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, errors),
  payerGroup: {
    limits: []
  }
});

/***/ }),

/***/ "g0Tg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http_portal__ = __webpack_require__("0/xT");




var Report = function () {
  function Report() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Report);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Report, [{
    key: 'download',
    value: function download(jobId) {
      return __WEBPACK_IMPORTED_MODULE_2__http_portal__["a" /* default */].get('/private/api/v1/report/download/' + jobId);
    }
  }]);

  return Report;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Report());

/***/ }),

/***/ "gElm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var SET_ERRORS_DOCS = function SET_ERRORS_DOCS(state, payload) {
  state.errors.docs = payload;
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, state.initialErrors);
};

var RESET_ERRORS_DOCS = function RESET_ERRORS_DOCS(state) {
  state.errors.docs = [];
};

/* harmony default export */ __webpack_exports__["a"] = ({
  RESET_ERRORS: RESET_ERRORS,
  SET_ERRORS_DOCS: SET_ERRORS_DOCS,
  RESET_ERRORS_DOCS: RESET_ERRORS_DOCS,
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "gOx0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_http__ = __webpack_require__("+bCW");




var _this = this;



var getProcessResult = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(context, jobId) {
    var response;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].get('/initial_load/job_status/', { params: { job_id: jobId } });

          case 2:
            response = _context.sent;

            if (!(response != null)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response.data));

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function getProcessResult(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  getProcessResult: getProcessResult
});

/***/ }),

/***/ "gS4T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatErrors;
function formatErrors(errors) {
  var errorString = errors.map(function (obj) {
    return '<li>' + obj + '</li>';
  }).join('');

  return '<ul>' + errorString + '</ul>';
}

/***/ }),

/***/ "gTDF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Activities = function () {
  function Activities() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Activities);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Activities, [{
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/activities/balance/' + id);
    }
  }, {
    key: 'create',
    value: function create(activity) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/activities', { activity: activity });
    }
  }]);

  return Activities;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Activities());

/***/ }),

/***/ "h9qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Profile = function () {
  function Profile() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Profile);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Profile, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/profile');
    }
  }, {
    key: 'permissions',
    value: function permissions() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('profile/permissions');
    }
  }, {
    key: 'dashboard',
    value: function dashboard() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/profile/dashboard');
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/profile', { user: payload });
    }
  }]);

  return Profile;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Profile());

/***/ }),

/***/ "hFK4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("DCaK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("zxkD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("qYBK");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "hPAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group form-md-line-input",class:{'has-error': _vm.hasErrors, 'has-success':(!_vm.hasErrors && _vm.validator.$dirty)}},[_vm._t("default"),_vm._v(" "),_vm._t("label",function(){return [(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label)+" "+_vm._s(_vm.hasErrors ? '*' : ''))]):_vm._e()]}),_vm._v(" "),(_vm.validator.$error)?_c('span',{staticClass:"help-block"},_vm._l((_vm.activeErrors),function(error){return _c('div',{staticClass:"error"},[_vm._v("\n      "+_vm._s(_vm.getErrorMessage(error.validationKey, error.params))+"\n    ")])}),0):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "igIV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_contact__ = __webpack_require__("iuAI");




var _this = this;



var resendInvite = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, id) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_contact__["a" /* default */].resendInvite(id).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function resendInvite(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createContact = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_contact__["a" /* default */].create(payload).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function createContact(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  resendInvite: resendInvite,
  createContact: createContact
});

/***/ }),

/***/ "iq7p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Contact = function () {
  function Contact() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Contact);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Contact, [{
    key: 'resendInvite',
    value: function resendInvite(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/contacts/' + id + '/send_welcome_email');
    }
  }, {
    key: 'create',
    value: function create(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/contacts/', { contact: payload });
    }
  }]);

  return Contact;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Contact());

/***/ }),

/***/ "jYXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("Zo+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("9+ld");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("obvb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("ABFm");





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "k/BA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var create = function create() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "ypzv"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/abc/create/:id',
  name: 'abc.create',
  component: create,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "kAs5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kKmc":
/***/ (function(module, exports) {



/***/ }),

/***/ "kR3n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage__ = __webpack_require__("22C0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_localforage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_localforage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_user__ = __webpack_require__("ye8Q");




var _this = this;





var switchCurrent = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].switchCurrent(payload).then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.setItem('new_current_user', response.data).then(function () {
                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setNewCurrentUser', response.data, { root: true });
                });
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function switchCurrent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var resetSwitch = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_5__services_user__["a" /* default */].resetSwitch().then(function (response) {
                __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.removeItem('new_current_user').then(function () {
                  __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('removeNewCurrent', { root: true });
                });
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function resetSwitch() {
    return _ref3.apply(this, arguments);
  };
}();
var getNewCurrent = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3_localforage___default.a.getItem('new_current_user').then(function (response) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('setNewCurrentUser', response, { root: true });
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function getNewCurrent(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  switchCurrent: switchCurrent,
  resetSwitch: resetSwitch,
  getNewCurrent: getNewCurrent
});

/***/ }),

/***/ "kopn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_operation__ = __webpack_require__("qYRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_export__ = __webpack_require__("oZsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;






var createOperation = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2) {
    var commit = _ref2.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_operation__["a" /* default */].create(payload).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                            type: 'error',
                            message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                          });
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function createOperation(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchForceRequest = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_operation__["a" /* default */].forceRequest(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function fetchForceRequest(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var exportCnabFile = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_export__["a" /* default */].cnabFile(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function exportCnabFile(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

var exportAssignmentRequestContrat = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_export__["a" /* default */].assignmentRequestContract(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function exportAssignmentRequestContrat(_x9, _x10) {
    return _ref6.apply(this, arguments);
  };
}();

var cancelRequest = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref8, id) {
    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_operation__["a" /* default */].cancelRequest(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function cancelRequest(_x11, _x12) {
    return _ref7.apply(this, arguments);
  };
}();

var acceptRequest = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(_ref10, id) {
    var commit = _ref10.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_operation__["a" /* default */].acceptRequest(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function acceptRequest(_x13, _x14) {
    return _ref9.apply(this, arguments);
  };
}();

var cancelManyRequest = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(_ref12, ids) {
    var commit = _ref12.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_operation__["a" /* default */].cancelManyRequest(ids).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function cancelManyRequest(_x15, _x16) {
    return _ref11.apply(this, arguments);
  };
}();

var acceptManyRequest = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(_ref14, ids) {
    var commit = _ref14.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_operation__["a" /* default */].acceptManyRequest(ids).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function acceptManyRequest(_x17, _x18) {
    return _ref13.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  createOperation: createOperation,
  fetchForceRequest: fetchForceRequest,
  exportCnabFile: exportCnabFile,
  cancelRequest: cancelRequest,
  acceptRequest: acceptRequest,
  cancelManyRequest: cancelManyRequest,
  acceptManyRequest: acceptManyRequest,
  exportAssignmentRequestContrat: exportAssignmentRequestContrat
});

/***/ }),

/***/ "kr/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var PayerGroup = function () {
  function PayerGroup() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PayerGroup);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PayerGroup, [{
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payer_groups/' + id);
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payer_groups', { params: params });
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/payer_groups', { payer_group: payload });
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/payer_groups/' + payload.id, { payer_group: payload });
    }
  }, {
    key: 'payers',
    value: function payers(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payer_groups/' + id + '/payers');
    }
  }]);

  return PayerGroup;
}();

/* harmony default export */ __webpack_exports__["a"] = (new PayerGroup());

/***/ }),

/***/ "lBjf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Payer = function () {
  function Payer() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Payer);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Payer, [{
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payers/' + id);
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/payers', { payer: payload });
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/payers/' + payload.id, { payer: payload });
    }
  }, {
    key: 'getCurrent',
    value: function getCurrent() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/current_payer');
    }
  }, {
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payers?per_page=100&simple=true&status=active');
    }
  }, {
    key: 'byCampaign',
    value: function byCampaign() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payers_for_campaign');
    }
  }, {
    key: 'getAssignors',
    value: function getAssignors(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/find_assignors_by_payer/' + id);
    }
  }, {
    key: 'paymentNotifications',
    value: function paymentNotifications(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/payer_payment_notifications/' + id + '/contacts/');
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/payer_payment_notifications/' + payload.assignment_request_id + '/resend/', { contact_ids: payload.contacts_ids });
    }
  }]);

  return Payer;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Payer());

/***/ }),

/***/ "mCmB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var informationCampaign = {
  legal_name: '',
  cnpj: '',
  total_invoices: 0,
  count_invoices: 0,
  count_assignors: 0,
  average_time: '',
  operation: {},
  errors: ['errors']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  listAvaliable: [],
  initInformationCampaign: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, informationCampaign),
  informationCampaign: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, informationCampaign)
});

/***/ }),

/***/ "mHHP":
/***/ (function(module, exports) {



/***/ }),

/***/ "mNto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_token__ = __webpack_require__("egOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var saveToken = function saveToken(context, payload) {
  var token = payload.token;

  var tenantAuthenticationToken = { payer_id: token.payer_id, request_host: token.request_host };

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_token__["a" /* default */].save(tenantAuthenticationToken).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

var removeToken = function removeToken(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_token__["a" /* default */].remove(payload.data.id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};

/* harmony default export */ __webpack_exports__["a"] = ({
  saveToken: saveToken,
  removeToken: removeToken
});

/***/ }),

/***/ "nNHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var subdomain = '' + window.location.host.split('.')[0];
/* harmony default export */ __webpack_exports__["a"] = (subdomain);

/***/ }),

/***/ "nbDU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Login = function Login() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, "Kqxw"));
};
var ForgotPassword = function ForgotPassword() {
  return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, "d8Y8"));
};
var AcceptTerms = function AcceptTerms() {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, "B2SD"));
};
var NewAssignor = function NewAssignor() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, "K6SJ"));
};
var NewPayer = function NewPayer() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, "oNtz"));
};
var ChangePassword = function ChangePassword() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, "h45F"));
};
var RedirectLogin = function RedirectLogin() {
  return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, "YczF"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/auth/login',
  name: 'auth.login',
  component: Login,
  meta: { requiresAuth: false, transition: 'fade' }
}, {
  path: '/auth/redirect-login',
  name: 'auth.redirect-login',
  component: RedirectLogin,
  meta: { requiresAuth: false, transition: 'fade' }
}, {
  path: '/auth/forgot-password',
  name: 'auth.forgot-password',
  component: ForgotPassword,
  meta: { requiresAuth: false, transition: 'fade' }
}, {
  path: '/auth/change-password/:token',
  name: 'auth.change-password',
  component: ChangePassword,
  meta: { requiresAuth: false, transition: 'fade' }
}, {
  path: '/auth/new-assignor/:token',
  name: 'auth.new-assignor',
  component: NewAssignor,
  meta: { requiresAuth: false, transition: 'fade' }
}, {
  path: '/auth/accept-terms',
  name: 'auth.accept-terms',
  component: AcceptTerms,
  meta: { requiresAuth: true, transition: 'fade' }
}, {
  path: '/auth/new-payer/:token',
  name: 'auth.new-payer',
  component: NewPayer,
  meta: { requiresAuth: false, transition: 'fade' }
}]);

/***/ }),

/***/ "nmxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_tenant__ = __webpack_require__("2pMd");




var _this = this;



var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_tenant__["a" /* default */].fetch().then(function (response) {
                commit('SET_LIST', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch
});

/***/ }),

/***/ "o3tJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_group_abc__ = __webpack_require__("+EQ7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var fetchGroupTaxByPayer = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_group_abc__["a" /* default */].taxByPayer(id).then(function (response) {
                          resolve(response);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchGroupTaxByPayer(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createGroupTax = function createGroupTax(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_group_abc__["a" /* default */].create(payload).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
};

var updateGroupTax = function updateGroupTax(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_group_abc__["a" /* default */].update(payload).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }());
};

var deleteGroupTax = function deleteGroupTax(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_3__services_group_abc__["a" /* default */].delete(payload).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }());
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchGroupTaxByPayer: fetchGroupTaxByPayer,
  createGroupTax: createGroupTax,
  updateGroupTax: updateGroupTax,
  deleteGroupTax: deleteGroupTax
});

/***/ }),

/***/ "oZsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Export = function () {
  function Export() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Export);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Export, [{
    key: 'assignors',
    value: function assignors() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/export_assignors');
    }
  }, {
    key: 'cnabFile',
    value: function cnabFile(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_cnab_file/' + id + '/download');
    }
  }, {
    key: 'assignmentRequestContract',
    value: function assignmentRequestContract(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/admin_back_office/export_assignment_request_contract/' + id);
    }
  }]);

  return Export;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Export());

/***/ }),

/***/ "obvb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_occurrence__ = __webpack_require__("RzKu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_dashboard__ = __webpack_require__("39Xj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_profile__ = __webpack_require__("h9qe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_tour__ = __webpack_require__("yvd/");




var _this = this;






var fetchSummary = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].getSummary().then(function (response) {
                commit('SET_DASHBOARD_SUMMARY', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchSummary(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchCorretor = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].fetchCorretor().then(function (response) {
                commit('SET_CORRETOR', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchCorretor(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchDashboard = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
    var commit = _ref6.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_5__services_profile__["a" /* default */].dashboard().then(function (response) {
                commit('SET_DASHBOARD', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function fetchDashboard(_x3) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchFinishTour = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(context, obj) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_tour__["a" /* default */].dashboardEnd().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function fetchFinishTour(_x4, _x5) {
    return _ref7.apply(this, arguments);
  };
}();

var fetchForceRequest = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].fetchForceRequest(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function fetchForceRequest(_x6, _x7) {
    return _ref8.apply(this, arguments);
  };
}();

var exportCnabFile = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].exportCnabFile(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function exportCnabFile(_x8, _x9) {
    return _ref9.apply(this, arguments);
  };
}();

var exportExcelAssigmentRequest = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].exportExcelAssigmentRequest(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function exportExcelAssigmentRequest(_x10, _x11) {
    return _ref10.apply(this, arguments);
  };
}();

var generateTermoCessao = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].generateTermoCessao(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function generateTermoCessao(_x12, _x13) {
    return _ref11.apply(this, arguments);
  };
}();

var exportCnabFileFromMultipleARs = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(context, ids) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].exportCnabFileFromMultipleARs(ids).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function exportCnabFileFromMultipleARs(_x14, _x15) {
    return _ref12.apply(this, arguments);
  };
}();

var getNestedOcurrenceByOcurrenceId = function () {
  var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_occurrence__["a" /* default */].nestedOccurrenceById(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error.response.data);
              });
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function getNestedOcurrenceByOcurrenceId(_x16, _x17) {
    return _ref13.apply(this, arguments);
  };
}();

var loadSummaryDatatable = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(_ref15, params) {
    var commit = _ref15.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_dashboard__["a" /* default */].loadSummaryDatatable(params).then(function (response) {
                commit('SET_SUMMARY_DATATABLE', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this);
  }));

  return function loadSummaryDatatable(_x18, _x19) {
    return _ref14.apply(this, arguments);
  };
}();

var updateValuesSumarize = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(_ref17, payload) {
    var commit = _ref17.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            commit('SET_SUMMARY_DATATABLE', payload);
            commit('SET_PARAMS_QUERY_SUMMARY_DATATABLE');

          case 2:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this);
  }));

  return function updateValuesSumarize(_x20, _x21) {
    return _ref16.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchSummary: fetchSummary,
  fetchDashboard: fetchDashboard,
  fetchCorretor: fetchCorretor,
  fetchFinishTour: fetchFinishTour,
  fetchForceRequest: fetchForceRequest,
  loadSummaryDatatable: loadSummaryDatatable,
  exportCnabFile: exportCnabFile,
  generateTermoCessao: generateTermoCessao,
  exportCnabFileFromMultipleARs: exportCnabFileFromMultipleARs,
  updateValuesSumarize: updateValuesSumarize,
  getNestedOcurrenceByOcurrenceId: getNestedOcurrenceByOcurrenceId,
  exportExcelAssigmentRequest: exportExcelAssigmentRequest
});

/***/ }),

/***/ "oqcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Step = function () {
  function Step() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Step);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Step, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/steps');
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/steps', { assignor: payload });
    }
  }, {
    key: 'sendDoc',
    value: function sendDoc() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/steps/send_documentations');
    }
  }]);

  return Step;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Step());

/***/ }),

/***/ "pBW3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);



var SET_FUND = function SET_FUND(state, payload) {
  state.fund = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload);
};

var RESET_STATE = function RESET_STATE(state) {
  state.fund = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.initialFund));
};

var SET_ERRORS = function SET_ERRORS(state, payload) {
  state.errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, payload);
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, state.initialErrors);
};

var UPDATE_VALUES = function UPDATE_VALUES(state, payload) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.fund, payload);
};

var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var RESET_LIST = function RESET_LIST(state) {
  state.list = [];
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_FUND: SET_FUND,
  RESET_STATE: RESET_STATE,
  SET_ERRORS: SET_ERRORS,
  RESET_ERRORS: RESET_ERRORS,
  UPDATE_VALUES: UPDATE_VALUES,
  SET_LIST: SET_LIST,
  RESET_LIST: RESET_LIST
});

/***/ }),

/***/ "pHr1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("JTRQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("pBW3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("V6bW");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "pWIH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_invoice__ = __webpack_require__("9PH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_report__ = __webpack_require__("g0Tg");




var _this = this;




var fetchInvoicesTotal = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].totalAvailable().then(function (response) {
                commit('SET_INVOICES_TOTAL', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetchInvoicesTotal(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchInvoicesSelected = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var commit = _ref4.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { invoice_ids: [] };
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].selectedAvailable(payload).then(function (response) {
                commit('SET_INVOICES_SELECTED', response.data);
                resolve(response.data);
              }).catch(function (error) {
                commit('SET_INVOICES_SELECTED', error.response.data);
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchInvoicesSelected(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var fetchSimulateInvoices = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6) {
    var commit = _ref6.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { invoice_ids: [] };
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].simulate(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function fetchSimulateInvoices(_x4) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchTaxCommission = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8) {
    var commit = _ref8.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].taxCommission().then(function (response) {
                commit('SET_TAX_COMMISSION', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function fetchTaxCommission(_x6) {
    return _ref7.apply(this, arguments);
  };
}();

var getInvoicesAvailable = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(context, page) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].available(page).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function getInvoicesAvailable(_x7, _x8) {
    return _ref9.apply(this, arguments);
  };
}();

var filterInvoices = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(context, filter) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_invoice__["a" /* default */].filterAvailable(filter).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function filterInvoices(_x9, _x10) {
    return _ref10.apply(this, arguments);
  };
}();

var downloadReport = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(context, jobId) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_report__["a" /* default */].download(jobId).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function downloadReport(_x11, _x12) {
    return _ref11.apply(this, arguments);
  };
}();

var removeInvoiceSelected = function removeInvoiceSelected(_ref12, payload) {
  var commit = _ref12.commit;

  commit('REMOVE_INVOICE_SELECTED', payload);
};

var resetInvoicesSelected = function resetInvoicesSelected(_ref13) {
  var commit = _ref13.commit;

  commit('RESET_INVOICES');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchInvoicesTotal: fetchInvoicesTotal,
  fetchInvoicesSelected: fetchInvoicesSelected,
  fetchTaxCommission: fetchTaxCommission,
  getInvoicesAvailable: getInvoicesAvailable,
  filterInvoices: filterInvoices,
  removeInvoiceSelected: removeInvoiceSelected,
  resetInvoicesSelected: resetInvoicesSelected,
  fetchSimulateInvoices: fetchSimulateInvoices,
  downloadReport: downloadReport
});

/***/ }),

/***/ "pfjc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("N0uf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("UHJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("nmxc");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "pz2A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var UserList = function UserList() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "QYXc"));
};
var UserNew = function UserNew() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, "5V5w"));
};
var UserEdit = function UserEdit() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, "2eNt"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/users',
  name: 'user.index',
  component: UserList,
  meta: { requiresAuth: true }
}, {
  path: '/users/new',
  name: 'user.new',
  component: UserNew,
  meta: {
    requiresAuth: true,
    permissions: ['user']
  }
}, {
  path: '/users/edit/:id',
  name: 'user.edit',
  component: UserEdit,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "qYBK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_import__ = __webpack_require__("qwtf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__ = __webpack_require__("//Ep");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;






var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_import__["a" /* default */].invoices().then(function (response) {
                commit('SET_LIST', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var destroy = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__["a" /* default */].delete(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function destroy(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var find = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref5, id) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__["a" /* default */].find(id).then(function (response) {
                commit('SET_GRAPH_INVOICES', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function find(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var findInvoices = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref7, id) {
    var commit = _ref7.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__["a" /* default */].findInvoices(id).then(function (response) {
                commit('SET_INVOICES_LIST', response.data.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function findInvoices(_x6, _x7) {
    return _ref6.apply(this, arguments);
  };
}();

var save = function save(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__["a" /* default */].save(payload).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_6__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                  type: 'error',
                  message: Object(__WEBPACK_IMPORTED_MODULE_5__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                });
                reject(error);
              });

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }());
};

var rebuild = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__["a" /* default */].rebuild(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function rebuild(_x10, _x11) {
    return _ref9.apply(this, arguments);
  };
}();

var sendEvaluationCerc = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_4__services_import_invoice__["a" /* default */].sendEvaluationCerc(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function sendEvaluationCerc(_x12, _x13) {
    return _ref10.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  find: find,
  save: save,
  destroy: destroy,
  findInvoices: findInvoices,
  rebuild: rebuild,
  sendEvaluationCerc: sendEvaluationCerc
});

/***/ }),

/***/ "qYPm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PayerGroupIndex = function PayerGroupIndex() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "oqtV"));
};
var PayerGroupNew = function PayerGroupNew() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, "wAGZ"));
};
var PayerGroupEdit = function PayerGroupEdit() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, "ecMh"));
};
var PayerGroupFormInfos = function PayerGroupFormInfos() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, "W00G"));
};
var PayerGroupFormTaxLimit = function PayerGroupFormTaxLimit() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, "GJV7"));
};

var PayerIndex = function PayerIndex() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "HFaG"));
};
var PayerEdit = function PayerEdit() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, "YNXN"));
};
var PayerNew = function PayerNew() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, "kYT2"));
};
var PayerFormInfos = function PayerFormInfos() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, "EQhY"));
};
var FormContact = function FormContact() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, "ln4z"));
};
var FormBranchOffices = function FormBranchOffices() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, "DBIP"));
};
var FormImportRule = function FormImportRule() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, "h6Jp"));
};
var PayerFormTaxLimit = function PayerFormTaxLimit() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, "8/I/"));
};
var FormLimit = function FormLimit() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, "FzOT"));
};
var TermFee = function TermFee() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, "0DKR"));
};
var FormFunds = function FormFunds() {
  return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, "87BP"));
};
var DocsPayer = function DocsPayer() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "iEjJ"));
};
var ListAssignors = function ListAssignors() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, "YMli"));
};
var Users = function Users() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "ouOC"));
};
var Classification = function Classification() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "v0xD"));
};

var AssignorsIndex = function AssignorsIndex() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "0oXU"));
};
var AssignorsNew = function AssignorsNew() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, "9yQN"));
};
var AssignorsEdit = function AssignorsEdit() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, "GwbF"));
};
var FormInfos = function FormInfos() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, "aOxY"));
};
var AssignorsFormContact = function AssignorsFormContact() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, "he4O"));
};
var BranchOffices = function BranchOffices() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, "liZU"));
};
var AssignorsFormImportRule = function AssignorsFormImportRule() {
  return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, "dbQQ"));
};
var FormTaxLimit = function FormTaxLimit() {
  return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, "Zxzn"));
};
var FormBankAccount = function FormBankAccount() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, "HaRP"));
};
var FormRepresentative = function FormRepresentative() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, "HGbt"));
};
var FormFund = function FormFund() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, "w//Y"));
};
var ListDocs = function ListDocs() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, "fzA/"));
};
var User = function User() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "bMFt"));
};
var HistorySerasa = function HistorySerasa() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, "HfKv"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/clients/payer-groups',
  name: 'payer-groups.index',
  component: PayerGroupIndex,
  meta: { requiresAuth: true }
}, {
  path: '/clients/payer-groups/new',
  name: 'payer-groups.new',
  component: PayerGroupNew,
  meta: { requiresAuth: true }
}, {
  path: '/clients/payer-groups/edit/:id',
  component: PayerGroupEdit,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'payer-groups.edit.infos',
    component: PayerGroupFormInfos,
    meta: { requiresAuth: true }
  }, {
    path: 'tax-limit',
    name: 'payer-groups.edit.tax-limit',
    component: PayerGroupFormTaxLimit,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/clients/payers',
  name: 'payers.index',
  component: PayerIndex,
  meta: { requiresAuth: true }
}, {
  path: '/clients/payers/new',
  component: PayerNew,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'payers.new.infos',
    component: PayerFormInfos,
    meta: { requiresAuth: true }
  }, {
    path: 'contact',
    name: 'payers.new.contact',
    component: FormContact,
    meta: { requiresAuth: true }
  }, {
    path: 'import-rule',
    name: 'payers.new.import-rule',
    component: FormImportRule,
    meta: { requiresAuth: true }
  }, {
    path: 'tax-limit',
    name: 'payers.new.tax-limit',
    component: PayerFormTaxLimit,
    meta: { requiresAuth: true }
  }, {
    path: 'limit',
    name: 'payers.new.limit',
    component: FormLimit,
    meta: { requiresAuth: true }
  }, {
    path: 'docs',
    name: 'payers.new.docs',
    component: DocsPayer,
    meta: { requiresAuth: true }
  }, {
    path: 'funds',
    name: 'payers.new.funds',
    component: FormFunds,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/clients/payers/edit/:id',
  component: PayerEdit,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'payers.edit.infos',
    component: PayerFormInfos,
    meta: { requiresAuth: true }
  }, {
    path: 'branch_offices',
    name: 'payers.edit.branch_offices',
    component: FormBranchOffices,
    meta: { requiresAuth: true }
  }, {
    path: 'contact',
    name: 'payers.edit.contact',
    component: FormContact,
    meta: { requiresAuth: true }
  }, {
    path: 'import-rule',
    name: 'payers.edit.import-rule',
    component: FormImportRule,
    meta: { requiresAuth: true }
  }, {
    path: 'tax-limit',
    name: 'payers.edit.tax-limit',
    component: PayerFormTaxLimit,
    meta: { requiresAuth: true }
  }, {
    path: 'limit',
    name: 'payers.edit.limit',
    component: FormLimit,
    meta: { requiresAuth: true }
  }, {
    path: 'term-fee',
    name: 'payers.new.term-fee',
    component: TermFee,
    meta: { requiresAuth: true }
  }, {
    path: 'docs',
    name: 'payers.edit.docs',
    component: DocsPayer,
    meta: { requiresAuth: true }
  }, {
    path: 'assignors',
    name: 'payers.edit.assignors',
    component: ListAssignors,
    meta: { requiresAuth: true }
  }, {
    path: 'funds',
    name: 'payers.edit.funds',
    component: FormFunds,
    meta: { requiresAuth: true }
  }, {
    path: 'users',
    name: 'payers.edit.users',
    component: Users,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/clients/payers/edit/:id/classification',
  name: 'payers.edit.classification',
  component: Classification,
  meta: { requiresAuth: true }
}, {
  path: '/clients/payers/classification',
  name: 'payers.classification',
  component: Classification,
  meta: { requiresAuth: true }
}, {
  path: '/assignors',
  name: 'assignors.index',
  component: AssignorsIndex,
  meta: { requiresAuth: true }
}, {
  path: '/assignors/new',
  component: AssignorsNew,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'assignors.new.infos',
    component: FormInfos,
    meta: { requiresAuth: true }
  }, {
    path: 'contact',
    name: 'assignors.new.contact',
    component: AssignorsFormContact,
    meta: { requiresAuth: true }
  }, {
    path: 'import_rule',
    name: 'assignors.new.import_rule',
    component: AssignorsFormImportRule,
    meta: { requiresAuth: true }
  }, {
    path: 'tax_limit',
    name: 'assignors.new.tax_limit',
    component: FormTaxLimit,
    meta: { requiresAuth: true }
  }, {
    path: 'bank_account',
    name: 'assignors.new.bank_account',
    component: FormBankAccount,
    meta: { requiresAuth: true }
  }, {
    path: 'representative',
    name: 'assignors.new.representative',
    component: FormRepresentative,
    meta: { requiresAuth: true }
  }]
}, {
  path: '/assignors/edit/:id',
  component: AssignorsEdit,
  meta: { requiresAuth: true },
  children: [{
    path: '/',
    name: 'assignors.edit',
    component: FormInfos,
    meta: { requiresAuth: true }
  }, {
    path: 'contact',
    name: 'assignors.edit.contact',
    component: AssignorsFormContact,
    meta: { requiresAuth: true }
  }, {
    path: 'branch_offices',
    name: 'assignors.edit.branch_offices',
    component: BranchOffices,
    meta: { requiresAuth: true }
  }, {
    path: 'import_rule',
    name: 'assignors.edit.import_rule',
    component: AssignorsFormImportRule,
    meta: { requiresAuth: true }
  }, {
    path: 'tax_limit',
    name: 'assignors.edit.tax_limit',
    component: FormTaxLimit,
    meta: { requiresAuth: true }
  }, {
    path: 'bank_account',
    name: 'assignors.edit.bank_account',
    component: FormBankAccount,
    meta: { requiresAuth: true }
  }, {
    path: 'representative',
    name: 'assignors.edit.representative',
    component: FormRepresentative,
    meta: { requiresAuth: true }
  }, {
    path: 'serasa',
    name: 'assignors.history_serasa',
    component: HistorySerasa,
    meta: { requiresAuth: true }
  }, {
    path: 'docs',
    name: 'assignors.edit.docs',
    component: ListDocs,
    meta: { requiresAuth: true }
  }, {
    path: 'funds',
    name: 'assignors.edit.funds',
    component: FormFund,
    meta: { requiresAuth: true }
  }, {
    path: 'users',
    name: 'assignors.edit.users',
    component: User,
    meta: { requiresAuth: true }
  }]
}]);

/***/ }),

/***/ "qYRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Operation = function () {
  function Operation() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Operation);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Operation, [{
    key: 'create',
    value: function create(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/operations', payload);
    }
  }, {
    key: 'forceRequest',
    value: function forceRequest(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/operations/' + payload.id + '/force_send_assignment_request');
    }
  }, {
    key: 'cancelRequest',
    value: function cancelRequest(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/operations/' + id + '/cancel');
    }
  }, {
    key: 'acceptRequest',
    value: function acceptRequest(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/operations/' + id + '/accept');
    }
  }, {
    key: 'cancelManyRequest',
    value: function cancelManyRequest(ids) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/operations/cancel_many', { assignment_request_ids: ids });
    }
  }, {
    key: 'acceptManyRequest',
    value: function acceptManyRequest(ids) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/operations/accept_many', { assignment_request_ids: ids });
    }
  }]);

  return Operation;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Operation());

/***/ }),

/***/ "qwtf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__http__ = __webpack_require__("+bCW");





var Import = function () {
  function Import() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Import);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Import, [{
    key: 'assignors',
    value: function assignors(payload) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post('/import_assignors', payload);
    }
  }, {
    key: 'templates',
    value: function templates() {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get('/import_templates');
    }
  }, {
    key: 'findTemplate',
    value: function findTemplate(payload) {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].post('/import_templates/get_templates', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, payload));
    }
  }, {
    key: 'invoices',
    value: function invoices() {
      return __WEBPACK_IMPORTED_MODULE_3__http__["a" /* default */].get('/import_invoices');
    }
  }]);

  return Import;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Import());

/***/ }),

/***/ "rLPp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var SET_SYSTEM_SETTINGS = function SET_SYSTEM_SETTINGS(state, obj) {
  state.systemSettings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj, {
    logo: obj['logo']['url'],
    logoAuth: obj['logo_auth']['url']
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SYSTEM_SETTINGS: SET_SYSTEM_SETTINGS
});

/***/ }),

/***/ "sCw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: [],
  permissions: [],
  current: {
    name: '',
    assignor: {
      assignor_type: '',
      vortx_assignor_integration_documents_status: ''
    }
  }
});

/***/ }),

/***/ "sD8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_http__ = __webpack_require__("+bCW");




var _this = this;


// import { formatErrors } from '@utils/errors-alert'

var resendInvite = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2, id) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        response = __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].post('/contacts/' + id + '/send_welcome_email');

                        response.then(function (response) {
                          resolve(response);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 2:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function resendInvite(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var createContact = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5, obj) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        console.log(obj);
                        response = __WEBPACK_IMPORTED_MODULE_3__services_http__["a" /* default */].post('/contacts/', { contact: obj });

                        response.then(function (response) {
                          resolve(response);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 3:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }));

              return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function createContact(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  resendInvite: resendInvite,
  createContact: createContact
});

/***/ }),

/***/ "sQep":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  list: []
});

/***/ }),

/***/ "swCI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("XB3y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("GLqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("MbCF");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "tGNB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST
});

/***/ }),

/***/ "tLvy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tYcp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uHIg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUrl = '' + "https://" + window.location.host.split('.')[0] + '.' + "api.creditcorp.com.br";
/* harmony default export */ __webpack_exports__["a"] = (baseUrl);

/***/ }),

/***/ "uSdp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TokenList = function TokenList() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "4n0S"));
};
var TokenNew = function TokenNew() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, "pLVC"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/tokens',
  name: 'token.index',
  component: TokenList,
  meta: { requiresAuth: true }
}, {
  path: '/tokens/new',
  name: 'token.new',
  component: TokenNew,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "ukTl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Funds = function () {
  function Funds() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Funds);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Funds, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/funds_by_list');
    }
  }, {
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/funds/' + id);
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/funds', { fund: payload });
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/funds/' + payload.id, { fund: payload });
    }
  }]);

  return Funds;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Funds());

/***/ }),

/***/ "uyIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_campaign__ = __webpack_require__("5fV2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;





var changeStatusCampaign = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(context) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { assignor_id: Int32Array, status: Boolean };
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].changeStatus(payload).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          __WEBPACK_IMPORTED_MODULE_5__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
                            type: 'error',
                            message: Object(__WEBPACK_IMPORTED_MODULE_4__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
                          });
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function changeStatusCampaign(_x) {
    return _ref.apply(this, arguments);
  };
}();

var changeStatusAproveRejectRequest = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(context, payload) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_campaign__["a" /* default */].changeStatusAproveReject(payload).then(function (response) {
                          resolve(response.data);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }));

              return function (_x7, _x8) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function changeStatusAproveRejectRequest(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  changeStatusCampaign: changeStatusCampaign,
  changeStatusAproveRejectRequest: changeStatusAproveRejectRequest
});

/***/ }),

/***/ "v3qv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("igIV");


/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),

/***/ "v5PU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  systemSettings: {
    menu_text_color: '',
    primary_color: '',
    secundary_color: '',
    logo: '',
    logoAuth: ''
  }
});

/***/ }),

/***/ "vGk4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var configs = {
  cnpj: '',
  primary_color: '',
  secundary_color: '',
  third_color: '',
  title: '',
  favicon_url: '',
  logo: '',
  logoUrl: '',
  logoAuth: '',
  button_auth_text_color: '',
  menu_text_color: '',
  subtitle_text_color: '',
  login_icons: '',
  email: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
  initialSystemSettings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, configs),
  systemSettings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, configs)
});

/***/ }),

/***/ "vrOo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__ = __webpack_require__("6pID");




var _this = this;



var acceptRequest = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref2, id) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__["a" /* default */].accept(id).then(function (response) {
                          resolve(response);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this);
              }));

              return function (_x3, _x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function acceptRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var rejectRequest = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5, id) {
    var commit = _ref5.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function () {
              var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve, reject) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        __WEBPACK_IMPORTED_MODULE_3__services_assignment_request__["a" /* default */].reject(id).then(function (response) {
                          resolve(response);
                        }).catch(function (error) {
                          reject(error);
                        });

                      case 1:
                      case 'end':
                        return _context3.stop();
                    }
                  }
                }, _callee3, _this);
              }));

              return function (_x7, _x8) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function rejectRequest(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
/* harmony default export */ __webpack_exports__["a"] = ({
  acceptRequest: acceptRequest,
  rejectRequest: rejectRequest
});

/***/ }),

/***/ "wUKe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wmAf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xlNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("QrMF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("gElm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("2tuA");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "xrnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("v5PU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("rLPp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("Y1Fv");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "ye8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var User = function () {
  function User() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, User);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(User, [{
    key: 'fetch',
    value: function fetch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/users');
    }
  }, {
    key: 'get',
    value: function get(id) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/users/' + id);
    }
  }, {
    key: 'update',
    value: function update(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/users/' + payload.id, { user: payload });
    }
  }, {
    key: 'save',
    value: function save(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/users', { user: payload });
    }
  }, {
    key: 'saveByToken',
    value: function saveByToken(token, user) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/user_payers/' + token, { user: user });
    }
  }, {
    key: 'findByToken',
    value: function findByToken(token) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/user_payers/token/' + token);
    }
  }, {
    key: 'switchCurrent',
    value: function switchCurrent(payload) {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].post('/switch_user_in', { switch_user: payload });
    }
  }, {
    key: 'resetSwitch',
    value: function resetSwitch() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].get('/switch_user_out');
    }
  }]);

  return User;
}();

/* harmony default export */ __webpack_exports__["a"] = (new User());

/***/ }),

/***/ "yoEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_export__ = __webpack_require__("oZsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_import__ = __webpack_require__("qwtf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_mailer__ = __webpack_require__("J2X2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_assignor__ = __webpack_require__("5J0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_documents__ = __webpack_require__("A7iJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_invoice__ = __webpack_require__("9PH6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_serasa__ = __webpack_require__("6zyl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_errors_alert__ = __webpack_require__("gS4T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_event_bus__ = __webpack_require__("6Rbp");




var _this = this;











var fetch = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
    var commit = _ref2.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].all().then(function (response) {
                commit('SET_LIST', response.data.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function fetch(_x) {
    return _ref.apply(this, arguments);
  };
}();

var fetchTemplateContractOptions = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4) {
    var commit = _ref4.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].templateContractOptions().then(function (response) {
                commit('SET_TEMPLATE_CONTRACT_OPTIONS', response.data);
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function fetchTemplateContractOptions(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var sendDocumentations = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, _ref7) {
    var commit = _ref6.commit;
    var id = _ref7.id,
        obj = _ref7.obj;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].sendDocumentations(id, obj).then(function (response) {
                commit('SET_ASSIGNOR', response.data);
                resolve(response);
              }).catch(function (error) {
                commit('SET_ERRORS', error.response.data);
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function sendDocumentations(_x3, _x4) {
    return _ref5.apply(this, arguments);
  };
}();

var fetchEligible = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref9) {
    var commit = _ref9.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].allElegible().then(function (response) {
                commit('SET_LIST', response.data.data);
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function fetchEligible(_x5) {
    return _ref8.apply(this, arguments);
  };
}();

var fetchCurrentAssignor = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref11) {
    var commit = _ref11.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].current().then(function (response) {
                commit('SET_CURRENT_ASSIGNOR', response.data);
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function fetchCurrentAssignor(_x6) {
    return _ref10.apply(this, arguments);
  };
}();

var fetchAssignorsWithInvoiceImported = function () {
  var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref13) {
    var commit = _ref13.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].withInvoices().then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function fetchAssignorsWithInvoiceImported(_x7) {
    return _ref12.apply(this, arguments);
  };
}();

var findInvoiceByAssignor = function () {
  var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_8__services_invoice__["a" /* default */].byAssignor().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function findInvoiceByAssignor(_x8, _x9) {
    return _ref14.apply(this, arguments);
  };
}();

var findByToken = function () {
  var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(context, token) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].byToken(token).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function findByToken(_x10, _x11) {
    return _ref15.apply(this, arguments);
  };
}();

var findSerasa = function () {
  var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].checkSerasa(id).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, _this);
  }));

  return function findSerasa(_x12, _x13) {
    return _ref16.apply(this, arguments);
  };
}();

var findAssignorsWithProtestos = function () {
  var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].withProtesto(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function findAssignorsWithProtestos(_x14, _x15) {
    return _ref17.apply(this, arguments);
  };
}();

var save = function save(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var verb = payload.verb,
        assignor = payload.assignor;

    var method = verb === 'put' ? 'update' : 'save';

    __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */][method](assignor).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_11__plugins_event_bus__["a" /* bus */].$emit('display-alert', {
        type: 'error',
        message: Object(__WEBPACK_IMPORTED_MODULE_10__utils_errors_alert__["a" /* formatErrors */])(error.response.data)
      });
      reject(error);
    });
  });
};

var saveUsingStore = function saveUsingStore(_ref18, payload) {
  var commit = _ref18.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var verb = payload.verb,
        dataAssignor = payload.dataAssignor;

    var method = verb === 'put' ? 'update' : 'save';
    payload.dataAssignor.min_value = payload.dataAssignor.min_value === 0 ? '' : payload.dataAssignor.min_value;

    __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */][method](dataAssignor).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      commit('SET_ERRORS', error.response.data);
      reject(error);
    });
  });
};

var saveByToken = function saveByToken(context, payload) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var token = payload.token,
        user = payload.user;


    __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].saveByToken(token, user).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};

var importAssignorList = function importAssignorList(_ref19, payload) {
  var commit = _ref19.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_4__services_import__["a" /* default */].assignors(payload).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      var response = error.response.data;
      var parsedErrors = [response.global_error, response.list_errors.map(function (error) {
        return 'Not imported line ' + error.line + ' - Assignor \'' + error.assignor + '\': ' + error.message;
      })];
      commit('SET_ERRORS', { import_assignors: parsedErrors });
      reject(error);
    });
  });
};

var exportAssignors = function () {
  var _ref20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_3__services_export__["a" /* default */].assignors().then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this);
  }));

  return function exportAssignors() {
    return _ref20.apply(this, arguments);
  };
}();

var resendWelcomeMailer = function resendWelcomeMailer(context, id) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__services_mailer__["a" /* default */].resendWelcomeEmail(id).then(function (response) {
      resolve(response);
    }).catch(function (error) {
      reject(error);
    });
  });
};

var find = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].get(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this);
  }));

  return function find(_x16, _x17) {
    return _ref21.apply(this, arguments);
  };
}();

var findCommit = function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(_ref23, id) {
    var commit = _ref23.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].get(id).then(function (response) {
                commit('SET_ASSIGNOR', response.data);
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, _this);
  }));

  return function findCommit(_x18, _x19) {
    return _ref22.apply(this, arguments);
  };
}();

var sendDocs = function sendDocs(_ref24, payload) {
  var commit = _ref24.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_7__services_documents__["a" /* default */].sendAssignorDocs(payload).then(function (response) {
      commit('SET_ASSIGNOR', response.data);
      commit('RESET_ERRORS_DOCS');
      resolve(response.data);
    }).catch(function (error) {
      commit('SET_ERRORS', error.response.data);
      reject(error);
    });
  });
};

var changeStatus = function changeStatus(_ref25, payload) {
  var commit = _ref25.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_7__services_documents__["a" /* default */].changeStatus(payload).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      commit('SET_ERRORS', error.response.data);
      reject(error);
    });
  });
};

var updateDocumentation = function updateDocumentation(_ref26, payload) {
  var commit = _ref26.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_7__services_documents__["a" /* default */].update(payload).then(function (response) {
      resolve(response.data);
      commit('RESET_ERRORS_DOCS');
    }).catch(function (error) {
      commit('SET_ERRORS', error.response.data);
      reject(error);
    });
  });
};

var getDocumentByAssignor = function getDocumentByAssignor(_ref27, id) {
  var commit = _ref27.commit;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].documents(id).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};

var fetchAssignorsByPayer = function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(_ref29) {
    var commit = _ref29.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].byPayers().then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, _this);
  }));

  return function fetchAssignorsByPayer(_x20) {
    return _ref28.apply(this, arguments);
  };
}();

var fetchUsersByAssignor = function () {
  var _ref30 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(_ref31, id) {
    var commit = _ref31.commit;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_6__services_assignor__["a" /* default */].users(id).then(function (response) {
                resolve(response.data);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, _this);
  }));

  return function fetchUsersByAssignor(_x21, _x22) {
    return _ref30.apply(this, arguments);
  };
}();

var approveProtestos = function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee16(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_9__services_serasa__["a" /* default */].approveProtestos(id).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context16.stop();
        }
      }
    }, _callee16, _this);
  }));

  return function approveProtestos(_x23, _x24) {
    return _ref32.apply(this, arguments);
  };
}();

var rejectProtestos = function () {
  var _ref33 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee17(context, id) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              __WEBPACK_IMPORTED_MODULE_9__services_serasa__["a" /* default */].rejectProtestos(id).then(function (response) {
                resolve(response);
              }).catch(function (error) {
                reject(error);
              });
            }));

          case 1:
          case 'end':
            return _context17.stop();
        }
      }
    }, _callee17, _this);
  }));

  return function rejectProtestos(_x25, _x26) {
    return _ref33.apply(this, arguments);
  };
}();

var resetStateAssignor = function resetStateAssignor(_ref34) {
  var commit = _ref34.commit;

  commit('RESET_ASSIGNOR');
};

var resetStateErrors = function resetStateErrors(_ref35) {
  var commit = _ref35.commit;

  commit('RESET_ERRORS');
};

var updateValues = function updateValues(_ref36, obj) {
  var commit = _ref36.commit;

  commit('UPDATE_VALUES', obj);
};

var resetStateErrorsDocs = function resetStateErrorsDocs(_ref37) {
  var commit = _ref37.commit;

  commit('RESET_ERRORS_DOCS');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  fetchEligible: fetchEligible,
  find: find,
  fetchCurrentAssignor: fetchCurrentAssignor,
  findByToken: findByToken,
  findSerasa: findSerasa,
  findAssignorsWithProtestos: findAssignorsWithProtestos,
  fetchAssignorsWithInvoiceImported: fetchAssignorsWithInvoiceImported,
  findInvoiceByAssignor: findInvoiceByAssignor,
  save: save,
  saveByToken: saveByToken,
  importAssignorList: importAssignorList,
  exportAssignors: exportAssignors,
  resendWelcomeMailer: resendWelcomeMailer,
  resetStateAssignor: resetStateAssignor,
  resetStateErrors: resetStateErrors,
  updateValues: updateValues,
  saveUsingStore: saveUsingStore,
  findCommit: findCommit,
  sendDocs: sendDocs,
  changeStatus: changeStatus,
  sendDocumentations: sendDocumentations,
  fetchTemplateContractOptions: fetchTemplateContractOptions,
  updateDocumentation: updateDocumentation,
  resetStateErrorsDocs: resetStateErrorsDocs,
  fetchAssignorsByPayer: fetchAssignorsByPayer,
  fetchUsersByAssignor: fetchUsersByAssignor,
  getDocumentByAssignor: getDocumentByAssignor,
  approveProtestos: approveProtestos,
  rejectProtestos: rejectProtestos
});

/***/ }),

/***/ "yvd/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__http__ = __webpack_require__("+bCW");




var Tour = function () {
  function Tour() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tour);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Tour, [{
    key: 'end',
    value: function end() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/tours/end_tour');
    }
  }, {
    key: 'dashboardEnd',
    value: function dashboardEnd() {
      return __WEBPACK_IMPORTED_MODULE_2__http__["a" /* default */].put('/tour/end_tour');
    }
  }]);

  return Tour;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Tour());

/***/ }),

/***/ "yzBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state__ = __webpack_require__("NRSB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__("Cgbl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("T80C");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: __WEBPACK_IMPORTED_MODULE_0__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),

/***/ "z1BS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var SET_PERMISSIONS = function SET_PERMISSIONS(state, permissions) {
  state.permissions = permissions;
};

var SET_CURRENT_USER = function SET_CURRENT_USER(state, user) {
  state.current = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user, {
    assignor: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, user.assignor, {
      is_progress: !user.assignor ? false : user.assignor.assignor_type === 'pending' && user.assignor.status_documentation === 'all_sended',
      is_pending: !user.assignor ? false : user.assignor.assignor_type === 'pending' && (user.assignor.status_documentation === 'none_doc' || user.assignor.status_documentation === 'incomplete'),
      is_done: !user.assignor ? false : user.assignor.assignor_type === 'complete'
    })
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_PERMISSIONS: SET_PERMISSIONS,
  SET_CURRENT_USER: SET_CURRENT_USER
});

/***/ }),

/***/ "zcS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_antecipation_request__ = __webpack_require__("XLAd");



var getAntecipationRequest = function getAntecipationRequest(context, id) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1__services_antecipation_request__["a" /* default */].get(id).then(function (response) {
      resolve(response.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAntecipationRequest: getAntecipationRequest
});

/***/ }),

/***/ "zenJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ConfirmationList = function ConfirmationList() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, "nUDx"));
};
var ShowConfirmation = function ShowConfirmation() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, "g9lW"));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/confirmation',
  name: 'confirmation.index',
  component: ConfirmationList,
  meta: { requiresAuth: true }
}, {
  path: '/confirmation/show',
  name: 'confirmation.show',
  component: ShowConfirmation,
  meta: { requiresAuth: true }
}]);

/***/ }),

/***/ "zwPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

var SET_SYSTEM_SETTINGS = function SET_SYSTEM_SETTINGS(state, obj) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state.systemSettings, obj);

  state.systemSettings.logoUrl = obj.logo.url;
  state.systemSettings.logoAuth = obj.logo_auth.url;
  state.systemSettings.favicon_url = obj.favicon.url;

  // button auth Wl
  state.systemSettings.btnWhiteLabel = {
    'color': obj.button_auth_text_color + ' !important',
    'background-color': obj.primary_color + ' !important',
    'border': '1px solid ' + obj.primary_color + ' !important'
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_SYSTEM_SETTINGS: SET_SYSTEM_SETTINGS
});

/***/ }),

/***/ "zxkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SET_LIST = function SET_LIST(state, payload) {
  state.list = payload;
};

var SET_INVOICES_LIST = function SET_INVOICES_LIST(state, payload) {
  state.listInvoices = payload;
};

var SET_GRAPH_INVOICES = function SET_GRAPH_INVOICES(state, payload) {
  state.graphInvoices = payload;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_INVOICES_LIST: SET_INVOICES_LIST,
  SET_GRAPH_INVOICES: SET_GRAPH_INVOICES
});

/***/ }),

/***/ "zzWR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


var SET_LIST = function SET_LIST(state, obj) {
  state.list = obj;
};

var SET_PAYER_GROUP = function SET_PAYER_GROUP(state, obj) {
  state.payerGroup = obj;
};

var UPDATE_VALUES = function UPDATE_VALUES(state, obj) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(state.payerGroup, obj);
};

var SET_ERRORS = function SET_ERRORS(state, obj) {
  state.errors = {
    'infos': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).reduce(function (acc, key) {
      if (!key.match(/\./)) {
        return acc.concat(obj[key]);
      }
      return acc;
    }, []),
    'taxLimit': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).reduce(function (acc, key) {
      if (key.match('limits.')) {
        return acc.concat(obj[key]);
      }
      return acc;
    }, [])
  };
};

var RESET_ERRORS = function RESET_ERRORS(state) {
  state.errors = state.initialErrors;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  SET_LIST: SET_LIST,
  SET_PAYER_GROUP: SET_PAYER_GROUP,
  UPDATE_VALUES: UPDATE_VALUES,
  SET_ERRORS: SET_ERRORS,
  RESET_ERRORS: RESET_ERRORS
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3b128ffebc77f8ceb640.js